const heart = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_107_2859)">
        <path
          d="M14.1695 0.929565C13.237 0.929565 12.3457 1.14334 11.5205 1.56499C10.9588 1.85196 10.4428 2.23324 10 2.68561C9.5572 2.23324 9.0412 1.85196 8.47946 1.56499C7.65423 1.14334 6.76297 0.929565 5.83043 0.929565C2.61555 0.929565 0 3.54511 0 6.76004C0 9.03711 1.2026 11.4555 3.57435 13.9482C5.55464 16.0295 7.97913 17.7645 9.66429 18.8534L10 19.0703L10.3357 18.8534C12.0209 17.7645 14.4454 16.0295 16.4257 13.9482C18.7974 11.4555 20 9.03711 20 6.76004C20 3.54511 17.3845 0.929565 14.1695 0.929565ZM15.5294 13.0955C13.7596 14.9555 11.6038 16.5368 10 17.5951C8.39616 16.5367 6.24037 14.9555 4.4706 13.0955C2.32499 10.8405 1.23711 8.70899 1.23711 6.76004C1.23711 4.22726 3.29769 2.16668 5.83047 2.16668C7.28866 2.16668 8.62817 2.83649 9.50544 4.00433L10 4.66268L10.4946 4.00433C11.3718 2.83649 12.7113 2.16668 14.1695 2.16668C16.7023 2.16668 18.7629 4.22726 18.7629 6.76004C18.7629 8.70899 17.675 10.8405 15.5294 13.0955Z"
          fill="#3EA8B8"
        />
      </g>
      <defs>
        <clipPath id="clip0_107_2859">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
const heartF = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M14.1695 0.929626C13.237 0.929626 12.3457 1.1434 11.5205 1.56505C10.9588 1.85202 10.4428 2.2333 10 2.68567C9.5572 2.2333 9.0412 1.85202 8.47946 1.56505C7.65423 1.1434 6.76297 0.929626 5.83043 0.929626C2.61555 0.929626 0 3.54517 0 6.7601C0 9.03717 1.2026 11.4556 3.57435 13.9483C5.55464 16.0296 7.97913 17.7645 9.66429 18.8535L10 19.0704L10.3357 18.8535C12.0209 17.7646 14.4454 16.0296 16.4256 13.9483C18.7974 11.4556 20 9.03717 20 6.7601C20 3.54517 17.3845 0.929626 14.1695 0.929626Z"
        fill="#3EA8B8"
      />
    </svg>
  );
};
const refresh = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_107_2862)">
        <path
          d="M19.7096 5.97115C19.4058 5.7641 18.9921 5.84234 18.785 6.14591L17.428 8.13557C17.0755 6.49311 16.2589 4.9839 15.0439 3.76893C13.379 2.10404 11.1654 1.18713 8.81081 1.18713C6.45628 1.18713 4.24262 2.10404 2.57772 3.76893C-0.85924 7.2059 -0.85924 12.7982 2.57772 16.2351C4.2962 17.9536 6.5535 18.8128 8.81081 18.8128C11.0681 18.8128 13.3254 17.9536 15.0439 16.2351C15.3037 15.9753 15.3037 15.554 15.0439 15.2942C14.7841 15.0343 14.3628 15.0343 14.103 15.2942C11.1848 18.2123 6.43685 18.2123 3.51875 15.2942C0.600652 12.3761 0.600652 7.62789 3.51875 4.70979C4.93234 3.29629 6.81174 2.51778 8.81089 2.51778C10.8101 2.51778 12.6895 3.29629 14.103 4.70988C15.1941 5.80083 15.9052 7.17165 16.1735 8.65984L13.8118 7.04906C13.5082 6.84201 13.0943 6.92025 12.8873 7.22382C12.6802 7.52738 12.7585 7.9413 13.062 8.14835L16.585 10.5512C16.5852 10.5513 16.5854 10.5515 16.5856 10.5517C16.6413 10.5896 16.7007 10.6176 16.7618 10.6366C16.7637 10.6373 16.7655 10.6382 16.7673 10.6388C16.7777 10.642 16.7883 10.6432 16.7987 10.6459C16.852 10.6592 16.9059 10.6673 16.9598 10.6673C17.1724 10.6673 17.3813 10.5657 17.5101 10.3769L19.8843 6.89577C20.0914 6.59211 20.0131 6.1782 19.7096 5.97115Z"
          fill="#3AA8B8"
        />
      </g>
      <defs>
        <clipPath id="clip0_107_2862">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
const wind = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <mask
        id="mask0_107_2893"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="30"
        height="30"
      >
        <rect width="30" height="30" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_107_2893)">
        <path
          d="M15.875 25.25C14.8333 25.25 13.9479 24.8854 13.2188 24.1562C12.4896 23.4271 12.125 22.5417 12.125 21.5H14.625C14.625 21.8542 14.7448 22.151 14.9844 22.3906C15.224 22.6302 15.5208 22.75 15.875 22.75C16.2292 22.75 16.526 22.6302 16.7656 22.3906C17.0052 22.151 17.125 21.8542 17.125 21.5C17.125 21.1458 17.0052 20.849 16.7656 20.6094C16.526 20.3698 16.2292 20.25 15.875 20.25H4V17.75H15.875C16.9167 17.75 17.8021 18.1146 18.5312 18.8438C19.2604 19.5729 19.625 20.4583 19.625 21.5C19.625 22.5417 19.2604 23.4271 18.5312 24.1562C17.8021 24.8854 16.9167 25.25 15.875 25.25ZM4 12.75V10.25H20.875C21.4167 10.25 21.8646 10.0729 22.2188 9.71875C22.5729 9.36458 22.75 8.91667 22.75 8.375C22.75 7.83333 22.5729 7.38542 22.2188 7.03125C21.8646 6.67708 21.4167 6.5 20.875 6.5C20.3333 6.5 19.8854 6.67708 19.5312 7.03125C19.1771 7.38542 19 7.83333 19 8.375H16.5C16.5 7.14583 16.9219 6.10938 17.7656 5.26562C18.6094 4.42188 19.6458 4 20.875 4C22.1042 4 23.1406 4.42188 23.9844 5.26562C24.8281 6.10938 25.25 7.14583 25.25 8.375C25.25 9.60417 24.8281 10.6406 23.9844 11.4844C23.1406 12.3281 22.1042 12.75 20.875 12.75H4ZM24.625 22.75V20.25C25.1667 20.25 25.6146 20.0729 25.9688 19.7188C26.3229 19.3646 26.5 18.9167 26.5 18.375C26.5 17.8333 26.3229 17.3854 25.9688 17.0312C25.6146 16.6771 25.1667 16.5 24.625 16.5H4V14H24.625C25.8542 14 26.8906 14.4219 27.7344 15.2656C28.5781 16.1094 29 17.1458 29 18.375C29 19.6042 28.5781 20.6406 27.7344 21.4844C26.8906 22.3281 25.8542 22.75 24.625 22.75Z"
          fill="#56585D"
        />
      </g>
    </svg>
  );
};
const erv = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_107_2868)">
        <path
          d="M23.2969 22.5937H22.5937V9.49305L22.8761 9.70399C23.1892 9.9379 23.6293 9.87049 23.8601 9.5614C24.0926 9.25029 24.0287 8.80967 23.7176 8.57731C23.6757 8.54595 20.5372 6.20193 12.4207 0.139842C12.1713 -0.0465325 11.8287 -0.0465325 11.5793 0.139842C11.3438 0.315763 0.788782 8.19912 0.282441 8.57731C-0.0287145 8.80967 -0.092558 9.25024 0.139847 9.5614C0.372159 9.87251 0.812735 9.9364 1.12389 9.70399L1.40626 9.49305V22.5937H0.703142C0.314831 22.5937 1.97764e-05 22.9085 1.97764e-05 23.2968C1.97764e-05 23.6852 0.314831 24 0.703142 24H23.2968C23.6851 24 23.9999 23.6852 23.9999 23.2968C23.9999 22.9085 23.6852 22.5937 23.2969 22.5937ZM2.81256 8.44278L12 1.58077L21.1875 8.44278V22.5937H2.81256V8.44278Z"
          fill="#3EA8B8"
        />
        <path
          d="M18.3284 13.3594C18.3284 11.6503 17.6575 10.0487 16.4395 8.84957C16.1627 8.57709 15.7175 8.5807 15.4451 8.8574C15.1727 9.13415 15.1762 9.57932 15.4529 9.85171C16.4004 10.7844 16.9221 12.0301 16.9221 13.3594C16.9221 16.0403 14.7675 18.2272 12.0989 18.2799L12.4974 17.8814C12.772 17.6068 12.772 17.1617 12.4974 16.8871C12.2229 16.6125 11.7777 16.6125 11.5031 16.8871L10.0968 18.2933C9.79864 18.5915 9.8226 19.1037 10.1621 19.3642L11.4721 20.8547C11.7281 21.146 12.1723 21.1754 12.4644 20.9187C12.7561 20.6624 12.7848 20.2181 12.5284 19.9264L12.3116 19.6797C15.6569 19.5168 18.3284 16.7443 18.3284 13.3594Z"
          fill="#3EA8B8"
        />
        <path
          d="M7.07817 13.3593C7.07817 10.6835 9.22456 8.49974 11.8861 8.43894L11.5028 8.82219C11.2282 9.09678 11.2282 9.54196 11.5028 9.81655C11.7774 10.0911 12.2226 10.0911 12.4972 9.81655L13.9034 8.4103C14.1719 8.14199 14.1802 7.70399 13.9135 7.42542L12.526 5.86148C12.2682 5.57105 11.8239 5.54442 11.5333 5.80219C11.2429 6.05991 11.2163 6.50433 11.474 6.79481L11.6906 7.03893C8.3444 7.20084 5.67188 9.97381 5.67188 13.3594C5.67188 15.0639 6.33965 16.6626 7.55221 17.8607C7.82704 18.1323 8.27226 18.1324 8.54657 17.8548C8.81947 17.5786 8.81685 17.1334 8.54061 16.8605C7.59754 15.9285 7.07817 14.6851 7.07817 13.3593Z"
          fill="#3EA8B8"
        />
      </g>
      <defs>
        <clipPath id="clip0_107_2868">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
const ervOff = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_107_2868)">
        <path
          d="M23.2969 22.5937H22.5937V9.49305L22.8761 9.70399C23.1892 9.9379 23.6293 9.87049 23.8601 9.5614C24.0926 9.25029 24.0287 8.80967 23.7176 8.57731C23.6757 8.54595 20.5372 6.20193 12.4207 0.139842C12.1713 -0.0465325 11.8287 -0.0465325 11.5793 0.139842C11.3438 0.315763 0.788782 8.19912 0.282441 8.57731C-0.0287145 8.80967 -0.092558 9.25024 0.139847 9.5614C0.372159 9.87251 0.812735 9.9364 1.12389 9.70399L1.40626 9.49305V22.5937H0.703142C0.314831 22.5937 1.97764e-05 22.9085 1.97764e-05 23.2968C1.97764e-05 23.6852 0.314831 24 0.703142 24H23.2968C23.6851 24 23.9999 23.6852 23.9999 23.2968C23.9999 22.9085 23.6852 22.5937 23.2969 22.5937ZM2.81256 8.44278L12 1.58077L21.1875 8.44278V22.5937H2.81256V8.44278Z"
          fill="#56585D"
        />
        <path
          d="M18.3284 13.3594C18.3284 11.6503 17.6575 10.0487 16.4395 8.84957C16.1627 8.57709 15.7175 8.5807 15.4451 8.8574C15.1727 9.13415 15.1762 9.57932 15.4529 9.85171C16.4004 10.7844 16.9221 12.0301 16.9221 13.3594C16.9221 16.0403 14.7675 18.2272 12.0989 18.2799L12.4974 17.8814C12.772 17.6068 12.772 17.1617 12.4974 16.8871C12.2229 16.6125 11.7777 16.6125 11.5031 16.8871L10.0968 18.2933C9.79864 18.5915 9.8226 19.1037 10.1621 19.3642L11.4721 20.8547C11.7281 21.146 12.1723 21.1754 12.4644 20.9187C12.7561 20.6624 12.7848 20.2181 12.5284 19.9264L12.3116 19.6797C15.6569 19.5168 18.3284 16.7443 18.3284 13.3594Z"
          fill="#56585D"
        />
        <path
          d="M7.07817 13.3593C7.07817 10.6835 9.22456 8.49974 11.8861 8.43894L11.5028 8.82219C11.2282 9.09678 11.2282 9.54196 11.5028 9.81655C11.7774 10.0911 12.2226 10.0911 12.4972 9.81655L13.9034 8.4103C14.1719 8.14199 14.1802 7.70399 13.9135 7.42542L12.526 5.86148C12.2682 5.57105 11.8239 5.54442 11.5333 5.80219C11.2429 6.05991 11.2163 6.50433 11.474 6.79481L11.6906 7.03893C8.3444 7.20084 5.67188 9.97381 5.67188 13.3594C5.67188 15.0639 6.33965 16.6626 7.55221 17.8607C7.82704 18.1323 8.27226 18.1324 8.54657 17.8548C8.81947 17.5786 8.81685 17.1334 8.54061 16.8605C7.59754 15.9285 7.07817 14.6851 7.07817 13.3593Z"
          fill="#56585D"
        />
      </g>
      <defs>
        <clipPath id="clip0_107_2868">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
const doas = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_107_2904)">
        <path
          d="M2.10938 9.89062C2.4977 9.89062 2.8125 9.57583 2.8125 9.1875C2.8125 8.79917 2.4977 8.48438 2.10938 8.48438C1.72105 8.48438 1.40625 8.79917 1.40625 9.1875C1.40625 9.57583 1.72105 9.89062 2.10938 9.89062Z"
          fill="#3EA8B8"
        />
        <path
          d="M2.10938 4.26562C2.4977 4.26562 2.8125 3.95083 2.8125 3.5625C2.8125 3.17417 2.4977 2.85938 2.10938 2.85938C1.72105 2.85938 1.40625 3.17417 1.40625 3.5625C1.40625 3.95083 1.72105 4.26562 2.10938 4.26562Z"
          fill="#3EA8B8"
        />
        <path
          d="M0.703125 12.7031C1.09145 12.7031 1.40625 12.3883 1.40625 12C1.40625 11.6117 1.09145 11.2969 0.703125 11.2969C0.3148 11.2969 0 11.6117 0 12C0 12.3883 0.3148 12.7031 0.703125 12.7031Z"
          fill="#3EA8B8"
        />
        <path
          d="M3.51562 12.7031C3.90395 12.7031 4.21875 12.3883 4.21875 12C4.21875 11.6117 3.90395 11.2969 3.51562 11.2969C3.1273 11.2969 2.8125 11.6117 2.8125 12C2.8125 12.3883 3.1273 12.7031 3.51562 12.7031Z"
          fill="#3EA8B8"
        />
        <path
          d="M0.703125 7.07812C1.09145 7.07812 1.40625 6.76333 1.40625 6.375C1.40625 5.98667 1.09145 5.67188 0.703125 5.67188C0.3148 5.67188 0 5.98667 0 6.375C0 6.76333 0.3148 7.07812 0.703125 7.07812Z"
          fill="#3EA8B8"
        />
        <path
          d="M3.51562 7.07812C3.90395 7.07812 4.21875 6.76333 4.21875 6.375C4.21875 5.98667 3.90395 5.67188 3.51562 5.67188C3.1273 5.67188 2.8125 5.98667 2.8125 6.375C2.8125 6.76333 3.1273 7.07812 3.51562 7.07812Z"
          fill="#3EA8B8"
        />
        <path
          d="M2.10938 15.5156C2.4977 15.5156 2.8125 15.2008 2.8125 14.8125C2.8125 14.4242 2.4977 14.1094 2.10938 14.1094C1.72105 14.1094 1.40625 14.4242 1.40625 14.8125C1.40625 15.2008 1.72105 15.5156 2.10938 15.5156Z"
          fill="#3EA8B8"
        />
        <path
          d="M2.10938 21.1406C2.4977 21.1406 2.8125 20.8258 2.8125 20.4375C2.8125 20.0492 2.4977 19.7344 2.10938 19.7344C1.72105 19.7344 1.40625 20.0492 1.40625 20.4375C1.40625 20.8258 1.72105 21.1406 2.10938 21.1406Z"
          fill="#3EA8B8"
        />
        <path
          d="M0.703125 18.3281C1.09145 18.3281 1.40625 18.0133 1.40625 17.625C1.40625 17.2367 1.09145 16.9219 0.703125 16.9219C0.3148 16.9219 0 17.2367 0 17.625C0 18.0133 0.3148 18.3281 0.703125 18.3281Z"
          fill="#3EA8B8"
        />
        <path
          d="M3.51562 18.3281C3.90395 18.3281 4.21875 18.0133 4.21875 17.625C4.21875 17.2367 3.90395 16.9219 3.51562 16.9219C3.1273 16.9219 2.8125 17.2367 2.8125 17.625C2.8125 18.0133 3.1273 18.3281 3.51562 18.3281Z"
          fill="#3EA8B8"
        />
        <path
          d="M23.9988 10.2603C23.9907 9.99136 23.8139 9.73987 23.5648 9.63905L21.4062 8.74842C21.0474 8.60039 20.6362 8.77125 20.4881 9.13022C20.34 9.48919 20.5109 9.90028 20.8699 10.0484L21.5488 10.3285L20.0001 11.0511C19.3222 11.3673 18.6104 11.4968 17.906 11.4416V7.26811C18.8168 7.32056 19.7364 7.14769 20.5946 6.74733L22.0771 6.05573L21.858 6.67744C21.7289 7.04367 21.9211 7.4452 22.2874 7.5743C22.6439 7.70288 23.0557 7.51467 23.1843 7.14487L23.9591 4.94644C24.087 4.60509 23.9041 4.19409 23.5648 4.06087L21.4062 3.17025C21.0474 3.02217 20.6362 3.19308 20.4881 3.55205C20.34 3.91102 20.5109 4.32211 20.8699 4.47019L21.5488 4.75036L20.0001 5.47289C19.3222 5.78911 18.6104 5.91862 17.906 5.86345V2.35134C17.9061 1.05478 16.8512 0 15.5547 0H7.9763C6.67978 0 5.625 1.05478 5.625 2.35134V21.6487C5.625 22.9452 6.67983 24 7.9763 24H15.5547C16.8512 24 17.906 22.9452 17.906 21.6487V18.4244C18.8168 18.4769 19.7364 18.304 20.5946 17.9036L22.0771 17.212L21.858 17.8337C21.7289 18.2 21.9211 18.6015 22.2874 18.7306C22.6439 18.8592 23.0557 18.671 23.1843 18.3012L23.9591 16.1027C24.087 15.7614 23.9041 15.3504 23.5648 15.2172L21.4062 14.3265C21.0474 14.1785 20.6362 14.3494 20.4881 14.7083C20.34 15.0673 20.5109 15.4784 20.8699 15.6265L21.5488 15.9067L20.0001 16.6292C19.3222 16.9454 18.6104 17.0749 17.906 17.0197V12.8462C18.8168 12.8987 19.7364 12.7258 20.5946 12.3255L22.0771 11.6339L21.858 12.2556C21.7289 12.6218 21.9211 13.0233 22.2874 13.1524C22.6439 13.281 23.0557 13.0928 23.1843 12.723L23.9591 10.5246C23.9881 10.44 24.0032 10.35 23.9988 10.2603ZM16.4998 16.6541C16.4069 16.6121 16.3145 16.5671 16.223 16.5181C14.4985 15.5956 12.5272 15.612 10.8142 16.5633L8.7855 17.69C8.44603 17.8785 8.32369 18.3066 8.51222 18.6461C8.70178 18.9888 9.13519 19.1062 9.46828 18.9194L11.4969 17.7927C12.7839 17.078 14.2646 17.0654 15.5596 17.7581C15.8647 17.9213 16.1793 18.0548 16.4998 18.1589V21.6487C16.4998 22.1698 16.0758 22.5938 15.5547 22.5938H7.9763C7.45519 22.5938 7.0312 22.1698 7.0312 21.6487V2.35134C7.0312 1.83023 7.45519 1.40625 7.9763 1.40625H15.5547C16.0758 1.40625 16.4998 1.83023 16.4998 2.35134V5.49783C16.4069 5.45583 16.3145 5.41083 16.223 5.36184C14.4985 4.4393 12.5272 4.4557 10.8142 5.40703L8.7855 6.53372C8.44603 6.72225 8.32369 7.15031 8.51222 7.48978C8.70178 7.83253 9.13519 7.94991 9.46828 7.76311L11.4969 6.63642C12.7839 5.92167 14.2646 5.90906 15.5596 6.60178C15.8647 6.76505 16.1793 6.89845 16.4998 7.00261V11.076C16.4069 11.034 16.3145 10.989 16.223 10.94C14.4985 10.0174 12.5272 10.0338 10.8142 10.9852L8.7855 12.1118C8.44603 12.3004 8.32369 12.7284 8.51222 13.0679C8.70178 13.4107 9.13519 13.528 9.46828 13.3412L11.4969 12.2145C12.7839 11.4998 14.2646 11.4872 15.5596 12.1799C15.8647 12.3432 16.1793 12.4766 16.4998 12.5807V16.6541Z"
          fill="#3EA8B8"
        />
      </g>
      <defs>
        <clipPath id="clip0_107_2904">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
const air = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="72"
      height="73"
      viewBox="0 0 72 73"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.6775 21.7143H54.3225C55.7925 21.7143 57 22.9181 57 24.3837V37.5473C57 39.9811 55.005 41.97 52.5638 41.97H19.4363C16.995 41.97 15 39.9811 15 37.5473V24.3837C15 22.9181 16.2075 21.7143 17.6775 21.7143ZM23.8725 40.0858H48.1538V38.9605C48.1538 38.5156 47.7863 38.1492 47.34 38.1492H24.6862C24.24 38.1492 23.8725 38.5156 23.8725 38.9605V40.0858ZM52.59 40.0858C53.9813 40.0858 55.1362 38.9605 55.1362 37.5473H55.11V34.3283H16.89V37.5473C16.89 38.9343 18.0188 40.0858 19.4363 40.0858H21.9825V38.9605C21.9825 37.4949 23.19 36.2911 24.66 36.2911H47.3662C48.8363 36.2911 50.0438 37.4949 50.0438 38.9605V40.0858H52.59ZM16.89 32.4703H55.1362V32.4441V24.3837C55.1362 23.9388 54.7687 23.5724 54.3225 23.5724H17.7037C17.2575 23.5724 16.89 23.9388 16.89 24.3837V32.4703ZM19.6988 26.6081C19.6988 26.1371 20.0925 25.7445 20.565 25.7445C21.0375 25.7445 21.4313 26.1371 21.4313 26.6081C21.4313 27.0792 21.0375 27.4717 20.565 27.4717C20.0925 27.4717 19.6988 27.0792 19.6988 26.6081ZM24.0563 25.7445C23.5838 25.7445 23.19 26.1371 23.19 26.6081C23.19 27.0792 23.5838 27.4717 24.0563 27.4717C24.5288 27.4717 24.9225 27.0792 24.9225 26.6081C24.9225 26.1371 24.5288 25.7445 24.0563 25.7445ZM52.9837 45.2413C53.0887 45.1628 53.2987 45.3198 53.2987 45.3198L53.1937 45.2675C53.2725 45.3722 53.115 45.5815 53.115 45.5815L52.5375 45.9217L53.01 46.0526C53.115 46.1049 53.1937 46.2096 53.1675 46.3405C53.1412 46.419 53.0625 46.4975 52.9575 46.4975H52.905L51.9862 46.262L51.0412 46.8115L51.9862 47.3611L52.905 47.1256C53.0362 47.0732 53.1675 47.1517 53.1937 47.2826C53.22 47.4134 53.0362 47.5705 53.0362 47.5705L52.5638 47.7013L53.1412 48.0415C53.22 48.12 53.2725 48.2509 53.22 48.3556C53.1675 48.4079 53.0887 48.4603 53.01 48.4603C52.9837 48.4603 52.905 48.4341 52.905 48.4341L52.3275 48.0939L52.4587 48.5649C52.485 48.6958 52.4325 48.8266 52.3013 48.8528H52.2487C52.17 48.8528 52.0387 48.6958 52.0387 48.6958L51.8025 47.7798L50.8575 47.2303V48.3294L51.5137 48.9837C51.5925 49.0622 51.5925 49.2192 51.5137 49.2977C51.4613 49.3762 51.4087 49.3762 51.3563 49.3762C51.3037 49.3762 51.1987 49.2977 51.1987 49.2977L50.8575 48.9575V49.6379C50.8575 49.7688 50.7525 49.8734 50.6213 49.8734C50.49 49.8734 50.385 49.6379 50.385 49.6379V48.9837L50.0438 49.3239C49.9912 49.4024 49.9388 49.4024 49.8862 49.4024C49.8337 49.4024 49.7812 49.3762 49.7287 49.3239C49.65 49.2454 49.7287 49.0098 49.7287 49.0098L50.385 48.3556V47.2564L49.44 47.806L49.2038 48.722C49.1775 48.8005 49.0988 48.879 48.9937 48.879H48.9412C48.8363 48.8266 48.7837 48.5911 48.7837 48.5911L48.915 48.12L48.3375 48.4603C48.3112 48.4864 48.2588 48.4864 48.2325 48.4864C48.1538 48.4864 48.075 48.4603 48.0225 48.3817C47.9437 48.2771 48.1012 48.0677 48.1012 48.0677L48.6787 47.7275L48.2062 47.5966C48.1012 47.5443 48.0225 47.4396 48.0488 47.3088C48.1012 47.1779 48.3375 47.1517 48.3375 47.1517L49.2562 47.3873L50.2012 46.8377L49.2562 46.2881L48.3375 46.5237H48.285C48.2062 46.5237 48.1012 46.4713 48.075 46.3666C48.0488 46.2358 48.2325 46.0788 48.2325 46.0788L48.705 45.9479L48.1275 45.6077C48.0488 45.5292 47.9963 45.3983 48.0488 45.2937C48.1275 45.189 48.3638 45.2151 48.3638 45.2151L48.9412 45.5554L48.81 45.0843C48.7837 44.9534 48.8363 44.8226 48.9675 44.7964C49.0987 44.7703 49.2562 44.9534 49.2562 44.9534L49.4925 45.8694L50.4375 46.419V45.3198L49.7812 44.6656C49.7025 44.5871 49.7025 44.43 49.7812 44.3515C49.86 44.273 50.0962 44.3515 50.0962 44.3515L50.4375 44.6917V44.0375C50.4375 43.9066 50.5425 43.802 50.6737 43.802C50.805 43.802 50.91 44.0375 50.91 44.0375V44.7179L51.2513 44.3777C51.33 44.2992 51.4875 44.2992 51.5662 44.3777C51.645 44.4562 51.5662 44.6917 51.5662 44.6917L50.91 45.346V46.4451L51.855 45.8956L52.0912 44.9796C52.1437 44.8749 52.275 44.7964 52.38 44.8226C52.5112 44.8749 52.5375 45.1105 52.5375 45.1105L52.4062 45.5815L52.9837 45.2413Z"
        fill="#56585D"
      />
    </svg>
  );
};
const dry = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="31"
      viewBox="0 0 30 31"
      fill="none"
    >
      <mask
        id="mask0_107_2977"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="30"
        height="31"
      >
        <rect y="0.854126" width="30" height="30" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_107_2977)">
        <path
          d="M23.4375 11.6666C22.875 12.2291 22.2292 12.6562 21.5 12.9478C20.7708 13.2395 20.0417 13.3853 19.3125 13.3853C18.5833 13.3853 17.8646 13.2447 17.1562 12.9635C16.4479 12.6822 15.8125 12.2499 15.25 11.6666L12.9062 9.32285C12.5938 9.01035 12.2396 8.77597 11.8438 8.61972C11.4479 8.46347 11.0417 8.38535 10.625 8.38535C10.2083 8.38535 9.80208 8.46347 9.40625 8.61972C9.01042 8.77597 8.65625 9.01035 8.34375 9.32285L6 11.6666L4.21875 9.88535L6.5625 7.5416C7.125 6.9791 7.76042 6.55722 8.46875 6.27597C9.17708 5.99472 9.89583 5.8541 10.625 5.8541C11.3542 5.8541 12.0677 5.99472 12.7656 6.27597C13.4635 6.55722 14.0938 6.9791 14.6562 7.5416L17 9.88535C17.3333 10.2187 17.6979 10.4635 18.0938 10.6197C18.4896 10.776 18.8958 10.8541 19.3125 10.8541C19.7292 10.8541 20.1406 10.776 20.5469 10.6197C20.9531 10.4635 21.3229 10.2187 21.6562 9.88535L24 7.5416L25.7812 9.32285L23.4375 11.6666ZM23.4375 17.9166C22.875 18.4791 22.2344 18.901 21.5156 19.1822C20.7969 19.4635 20.0729 19.6041 19.3438 19.6041C18.6146 19.6041 17.8906 19.4635 17.1719 19.1822C16.4531 18.901 15.8125 18.4791 15.25 17.9166L12.9062 15.5728C12.5938 15.2603 12.2396 15.026 11.8438 14.8697C11.4479 14.7135 11.0417 14.6353 10.625 14.6353C10.2083 14.6353 9.80208 14.7135 9.40625 14.8697C9.01042 15.026 8.65625 15.2603 8.34375 15.5728L6 17.9166L4.21875 16.1666L6.5625 13.7916C7.125 13.2291 7.76042 12.8072 8.46875 12.526C9.17708 12.2447 9.89583 12.1041 10.625 12.1041C11.3542 12.1041 12.0677 12.2447 12.7656 12.526C13.4635 12.8072 14.0938 13.2291 14.6562 13.7916L17 16.1353C17.3333 16.4687 17.6979 16.7135 18.0938 16.8697C18.4896 17.026 18.8958 17.1041 19.3125 17.1041C19.7292 17.1041 20.1406 17.026 20.5469 16.8697C20.9531 16.7135 21.3229 16.4687 21.6562 16.1353L24 13.7916L25.7812 15.5728L23.4375 17.9166ZM23.4062 24.1666C22.8438 24.7291 22.2083 25.151 21.5 25.4322C20.7917 25.7135 20.0729 25.8541 19.3438 25.8541C18.6146 25.8541 17.8906 25.7135 17.1719 25.4322C16.4531 25.151 15.8125 24.7291 15.25 24.1666L12.875 21.8228C12.5625 21.5103 12.2083 21.276 11.8125 21.1197C11.4167 20.9635 11.0104 20.8853 10.5938 20.8853C10.1771 20.8853 9.77083 20.9635 9.375 21.1197C8.97917 21.276 8.625 21.5103 8.3125 21.8228L5.96875 24.1666L4.21875 22.4166L6.5625 20.0416C7.125 19.4791 7.76042 19.0572 8.46875 18.776C9.17708 18.4947 9.89583 18.3541 10.625 18.3541C11.3542 18.3541 12.0677 18.4947 12.7656 18.776C13.4635 19.0572 14.0938 19.4791 14.6562 20.0416L17 22.3853C17.3333 22.7187 17.7031 22.9635 18.1094 23.1197C18.5156 23.276 18.9271 23.3541 19.3438 23.3541C19.7604 23.3541 20.1667 23.276 20.5625 23.1197C20.9583 22.9635 21.3229 22.7187 21.6562 22.3853L24 20.0416L25.75 21.8228L23.4062 24.1666Z"
          fill="#56585D"
        />
      </g>
    </svg>
  );
};
const cool = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="31"
      viewBox="0 0 30 31"
      fill="none"
    >
      <mask
        id="mask0_107_2984"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="30"
        height="31"
      >
        <rect y="0.854126" width="30" height="30" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_107_2984)">
        <path
          d="M13.75 28.3541V23.1666L9.6875 27.1666L7.9375 25.4166L13.75 19.6041V17.1041H11.25L5.4375 22.9166L3.6875 21.1666L7.6875 17.1041H2.5V14.6041H7.6875L3.6875 10.5416L5.4375 8.79163L11.25 14.6041H13.75V12.1041L7.9375 6.29163L9.6875 4.54163L13.75 8.54163V3.35413H16.25V8.54163L20.3125 4.54163L22.0625 6.29163L16.25 12.1041V14.6041H18.75L24.5625 8.79163L26.3125 10.5416L22.3125 14.6041H27.5V17.1041H22.3125L26.3125 21.1666L24.5625 22.9166L18.75 17.1041H16.25V19.6041L22.0625 25.4166L20.3125 27.1666L16.25 23.1666V28.3541H13.75Z"
          fill="#56585D"
        />
      </g>
    </svg>
  );
};
const eco = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="31"
      viewBox="0 0 30 31"
      fill="none"
    >
      <mask
        id="mask0_107_2991"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="30"
        height="31"
      >
        <rect y="0.854126" width="30" height="30" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_107_2991)">
        <path
          d="M15 25.8541C13.8333 25.8541 12.7344 25.6718 11.7031 25.3073C10.6719 24.9427 9.72917 24.427 8.875 23.7604L7.125 25.4791C6.89583 25.7083 6.60417 25.8229 6.25 25.8229C5.89583 25.8229 5.60417 25.7083 5.375 25.4791C5.14583 25.25 5.03125 24.9583 5.03125 24.6041C5.03125 24.25 5.14583 23.9583 5.375 23.7291L7.09375 22.0104C6.42708 21.1562 5.91146 20.2083 5.54688 19.1666C5.18229 18.125 5 17.0208 5 15.8541C5 13.0625 5.96875 10.6979 7.90625 8.76038C9.84375 6.82288 12.2083 5.85413 15 5.85413H25V15.8541C25 18.6458 24.0312 21.0104 22.0938 22.9479C20.1562 24.8854 17.7917 25.8541 15 25.8541ZM15 23.3541C17.0833 23.3541 18.8542 22.625 20.3125 21.1666C21.7708 19.7083 22.5 17.9375 22.5 15.8541V8.35413H15C12.9167 8.35413 11.1458 9.08329 9.6875 10.5416C8.22917 12 7.5 13.7708 7.5 15.8541C7.5 16.6666 7.625 17.4427 7.875 18.1823C8.125 18.9218 8.46875 19.5937 8.90625 20.1979L15.375 13.7291C15.6042 13.5 15.8958 13.3854 16.25 13.3854C16.6042 13.3854 16.8958 13.5 17.125 13.7291C17.375 13.9791 17.5 14.276 17.5 14.6198C17.5 14.9635 17.375 15.2604 17.125 15.5104L10.6562 21.9791C11.2604 22.4166 11.9323 22.7552 12.6719 22.9948C13.4115 23.2343 14.1875 23.3541 15 23.3541Z"
          fill="#56585D"
        />
      </g>
    </svg>
  );
};
const auto = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_1424_10884"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="30"
        height="30"
      >
        <rect width="30" height="30" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1424_10884)"></g>
      <path
        d="M18.9455 18.7899L14.7644 10.4253C14.48 9.85822 13.5527 9.85822 13.2683 10.4253L9.08718 18.7899C8.8823 19.2006 9.05122 19.7067 9.46097 19.9124C9.87073 20.1182 10.3775 19.9484 10.5832 19.5385L11.6059 17.4909H16.426L17.4495 19.5377C17.6611 19.889 18.0533 20.063 18.3886 19.9785C18.8234 19.8681 19.1295 19.3269 18.9455 18.7899ZM12.4421 15.818L14.0159 12.6696L15.5897 15.818H12.4421Z"
        fill="#56585D"
        stroke="#56585D"
        strokeWidth="0.5"
      />
      <path
        d="M1.75 15.5C1.75 22.5306 7.46943 28.25 14.5 28.25C21.5306 28.25 27.25 22.5306 27.25 15.5C27.25 8.46943 21.5306 2.75 14.5 2.75C7.46943 2.75 1.75 8.46943 1.75 15.5ZM3.91667 15.5C3.91667 9.66474 8.66474 4.91667 14.5 4.91667C20.3353 4.91667 25.0833 9.66474 25.0833 15.5C25.0833 21.3353 20.3353 26.0833 14.5 26.0833C8.66474 26.0833 3.91667 21.3353 3.91667 15.5Z"
        fill="#56585D"
        stroke="#56585D"
        strokeWidth="0.5"
      />
    </svg>
  );
};
const floor_lamp = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="34"
      viewBox="0 0 17 34"
      fill="none"
    >
      <g clipPath="url(#clip0_381_329)">
        <path
          d="M16.1917 11.3356L13.4829 2.36032C13.1393 1.26873 12.1488 0.520798 10.9966 0.520798H4.95242C3.77998 0.520798 2.74904 1.30916 2.44582 2.46139L0.0807199 11.4366C-0.121425 12.225 0.0402909 13.0336 0.525439 13.6805C1.01059 14.3273 1.77874 14.6912 2.58732 14.6912H7.43881V31.6714H5.53864C5.11414 31.6714 4.77049 32.015 4.77049 32.4395C4.77049 32.864 5.11414 33.2077 5.53864 33.2077H10.8551C11.2796 33.2077 11.6232 32.864 11.6232 32.4395C11.6232 32.015 11.2796 31.6714 10.8551 31.6714H8.9549V14.6912H11.4413V16.4296C11.4413 16.8541 11.7849 17.1978 12.2094 17.1978C12.6339 17.1978 12.9776 16.8541 12.9776 16.4296V14.6912H13.7457C14.5745 14.6912 15.3427 14.3071 15.8278 13.64C16.3332 12.9729 16.4747 12.1441 16.2321 11.3356H16.1917ZM2.36496 8.68746H13.8064L14.15 9.83969H2.08196L2.38518 8.68746H2.36496ZM3.92148 2.84547C4.04277 2.38053 4.46727 2.03689 4.97263 2.03689H11.0168C11.5019 2.03689 11.9062 2.3401 12.0477 2.80504L13.3819 7.17137H2.76925L3.92148 2.84547ZM14.5745 12.7304C14.3724 13.0134 14.049 13.1549 13.7053 13.1549H2.58732C2.24367 13.1549 1.94046 12.9932 1.73831 12.7304C1.53617 12.4676 1.45531 12.1239 1.55638 11.8005L1.67767 11.3356H14.615L14.7362 11.7601C14.8373 12.0835 14.7767 12.4474 14.5745 12.7102V12.7304Z"
          fill="#56585D"
        />
      </g>
      <defs>
        <clipPath id="clip0_381_329">
          <rect
            width="16.3131"
            height="32.6667"
            fill="white"
            transform="translate(0 0.520798)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
const chandelier = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="56"
      height="34"
      viewBox="0 0 56 57"
      fill="none"
    >
      <path
        d="M44.231 33.2362L42.5354 28.088C42.2085 27.1278 41.3096 26.4741 40.2881 26.4741H35.3238C34.3023 26.4741 33.4034 27.1278 33.0766 28.088L31.3809 33.2362C31.2992 33.4814 31.2583 33.7266 31.2583 33.9921V35.177C31.2583 36.4845 32.3207 37.5264 33.6281 37.5264H36.9173V39.3242C36.9173 40.7134 35.7732 41.8575 34.384 41.8575H31.5852C30.1756 41.8575 28.9907 40.693 28.9907 39.3242V14.4412H32.954C33.4851 14.4412 33.9142 14.0121 33.9142 13.481C33.9142 12.9498 33.4851 12.5208 32.954 12.5208H23.0866C22.5554 12.5208 22.1264 12.9498 22.1264 13.481C22.1264 14.0121 22.5554 14.4412 23.0866 14.4412H27.0499V39.3038C27.0499 40.693 25.9058 41.837 24.5166 41.837H21.7791C20.3899 41.837 19.2458 40.693 19.2458 39.3038V37.506H22.4124C23.7199 37.506 24.7618 36.4437 24.7618 35.1566V33.9717C24.7618 33.7061 24.7209 33.461 24.6392 33.2158L22.9436 28.0676C22.6167 27.1074 21.7178 26.4537 20.6963 26.4537H15.732C14.7105 26.4537 13.8116 27.1074 13.4847 28.0676L11.7891 33.2158C11.7074 33.461 11.6665 33.7061 11.6665 33.9717V35.1566C11.6665 36.4641 12.7288 37.506 14.0363 37.506H17.3255V39.3038C17.3255 41.7553 19.3275 43.7574 21.7791 43.7574H24.5166C25.9467 43.7574 27.1929 43.0628 28.0101 42.0209C28.8477 43.0628 30.1143 43.7574 31.5648 43.7574H34.3636C36.8151 43.7574 38.8172 41.7553 38.8172 39.3038V37.506H41.9838C43.2913 37.506 44.3332 36.4437 44.3332 35.1566V33.9717C44.3332 33.7061 44.2923 33.461 44.2106 33.2158L44.231 33.2362ZM13.5869 35.1566V33.8287L15.3234 28.6805C15.3847 28.4966 15.5481 28.374 15.732 28.374H20.6963C20.8802 28.374 21.0436 28.4966 21.1049 28.6805L22.8414 33.9717V35.1566C22.8414 35.4018 22.6371 35.5856 22.4124 35.5856H14.0363C13.7912 35.5856 13.6073 35.3813 13.6073 35.1566H13.5869ZM42.4332 35.1566C42.4332 35.4018 42.2289 35.5856 42.0042 35.5856H33.6281C33.383 35.5856 33.1991 35.3813 33.1991 35.1566V33.8287L34.9356 28.6805C34.9969 28.4966 35.1604 28.374 35.3442 28.374H40.3086C40.4924 28.374 40.6559 28.4966 40.7172 28.6805L42.4537 33.9717V35.1566H42.4332Z"
        fill="#56585D"
      />
    </svg>
  );
};
const curtain = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="72"
      height="73"
      viewBox="0 0 72 73"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M54.9875 16.8042C54.9875 16.2791 55.4125 15.8541 55.9376 15.8541C56.4626 15.8541 56.8876 16.2791 56.8876 16.8042V18.5043C56.8876 19.0293 56.4626 19.4543 55.9376 19.4543C55.4875 19.4543 55.1125 19.1293 55.0375 18.6793H16.8356C16.7606 19.1043 16.3856 19.4543 15.9356 19.4543C15.4106 19.4543 14.9855 19.0293 14.9855 18.5293V16.8042C14.9855 16.2791 15.3856 15.8541 15.9106 15.8541C16.4356 15.8541 16.8606 16.2791 16.8606 16.8042H54.9875ZM56.4626 21.9044C56.8876 22.2045 56.9876 22.7795 56.6876 23.2045H56.7376L56.6876 23.2545C56.8126 23.4045 56.9126 23.6045 56.9126 23.8295V56.8312C56.9126 57.3562 56.4876 57.7812 55.9625 57.7812H47.3121C46.7871 57.7812 46.3621 57.3562 46.3621 56.8312C46.3621 48.4057 50.2123 42.4054 51.4123 40.7054C47.8872 38.0802 40.8868 32.0049 40.3368 24.7546C38.9451 24.7297 38.2204 24.1861 37.6225 23.7377L37.6116 23.7295C37.1116 23.3295 36.7866 23.0795 35.9616 23.0795C35.1365 23.0795 34.7365 23.3545 34.2115 23.7295C34.1827 23.7491 34.1537 23.7689 34.1243 23.789C33.5139 24.2062 32.7482 24.7296 31.4363 24.7296C30.9113 31.6549 24.461 37.5302 20.8108 40.3303C21.9359 42.1554 25.386 48.4807 25.386 56.8062C25.386 57.3312 24.961 57.7562 24.436 57.7562H15.9356C15.4106 57.7562 14.9855 57.3312 14.9855 56.8062V23.8295C14.9855 23.6542 15.0462 23.4941 15.0967 23.361C15.111 23.3232 15.1245 23.2876 15.1355 23.2545L15.0855 23.2045C14.7855 22.7795 14.8855 22.2045 15.3105 21.9044C16.0356 21.4044 16.7606 21.1794 17.7357 21.1794C19.1607 21.1794 19.9358 21.7544 20.5358 22.2045C21.0358 22.6045 21.3858 22.8545 22.2109 22.8545C23.0261 22.8545 23.402 22.586 23.9173 22.2178L23.936 22.2045C24.411 21.8544 24.961 21.4544 25.8361 21.2794V20.2544C25.8361 19.7293 26.2611 19.3043 26.7861 19.3043C27.3111 19.3043 27.7362 19.7293 27.7362 20.2544V21.2794C28.6112 21.4544 29.1612 21.8544 29.6113 22.2045L29.6172 22.209C30.1387 22.6063 30.4644 22.8545 31.2863 22.8545C32.1114 22.8545 32.5114 22.5795 33.0364 22.2045C33.5114 21.8544 34.0615 21.4544 34.9365 21.2794V20.2544C34.9365 19.7293 35.3615 19.3043 35.8866 19.3043C36.4116 19.3043 36.8366 19.7293 36.8366 20.2544V21.2794C37.6866 21.4794 38.2367 21.8794 38.6867 22.2295L38.6926 22.234C39.2142 22.6314 39.5398 22.8795 40.3618 22.8795C41.1677 22.8795 41.568 22.5932 42.0755 22.2305C42.0875 22.2218 42.0997 22.2132 42.1119 22.2045C42.5869 21.8544 43.1369 21.4544 44.012 21.2794V20.2544C44.012 19.7293 44.437 19.3043 44.962 19.3043C45.487 19.3043 45.9121 19.7293 45.9121 20.2544V21.2794C46.7621 21.4794 47.3121 21.8794 47.7621 22.2295C48.2622 22.6295 48.5872 22.8795 49.4122 22.8795C50.2004 22.8795 50.6007 22.6057 51.1145 22.2542C51.1385 22.2378 51.1628 22.2212 51.1873 22.2045C51.8123 21.7294 52.6124 21.1794 54.0375 21.1794C55.0375 21.1794 55.7375 21.4044 56.4626 21.9044ZM16.8606 55.8561H23.486C23.2109 48.3307 19.9858 42.6055 19.1107 41.1554H16.8606V55.8561ZM16.8606 39.3053H19.0107C21.7109 37.3052 29.1612 31.2049 29.5362 24.3546C29.1112 24.1545 28.7862 23.9295 28.5112 23.7045L28.5053 23.7C27.9837 23.3026 27.658 23.0545 26.8361 23.0545C26.0209 23.0545 25.645 23.323 25.1297 23.6912L25.111 23.7045C25.0915 23.7186 25.0719 23.7327 25.0522 23.747C24.4385 24.1899 23.6907 24.7296 22.2859 24.7296C20.8358 24.7296 20.0608 24.1545 19.4608 23.7045C18.9607 23.3045 18.6107 23.0545 17.7857 23.0545C17.2106 23.0545 16.9106 23.1545 16.6606 23.3045C16.7856 23.4545 16.8606 23.6295 16.8606 23.8295V39.3053ZM48.2372 55.8561H54.9875V41.1804H53.3124C53.3065 41.1922 53.3006 41.2054 53.2944 41.2193C53.2742 41.2644 53.2506 41.3172 53.2124 41.3554C53.1624 41.4054 48.5622 47.2557 48.2372 55.8561ZM54.9875 39.3053V23.8295L54.9625 23.8045C54.9625 23.6045 55.0625 23.4295 55.1625 23.2795C54.9125 23.1295 54.6125 23.0295 54.0375 23.0295C53.2493 23.0295 52.849 23.3033 52.3352 23.6548C52.3112 23.6712 52.2869 23.6878 52.2624 23.7045C51.6373 24.1545 50.8623 24.7046 49.4122 24.7046C47.9784 24.7046 47.229 24.1424 46.6323 23.6947L46.6121 23.6795C46.1121 23.2795 45.787 23.0295 44.962 23.0295C44.1561 23.0295 43.7558 23.3157 43.2483 23.6785C43.2363 23.6871 43.2241 23.6958 43.2119 23.7045C42.9119 23.9295 42.5869 24.1545 42.1619 24.3546C42.5369 31.2049 49.9873 37.3052 52.6874 39.3053H54.9875Z"
        fill="#56585D"
      />
    </svg>
  );
};
const less = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="12"
      viewBox="0 0 8 12"
      fill="none"
    >
      <g clipPath="url(#clip0_107_3021)">
        <path
          d="M1.11895 6.6874L1.11897 6.68742L5.63376 11.1099C6.01815 11.4866 6.63938 11.4867 7.02368 11.1099C7.41075 10.7306 7.41073 10.1135 7.0236 9.73425C7.02359 9.73425 7.02359 9.73425 7.02359 9.73424L3.21098 5.99956L7.02348 2.265L7.02352 2.26496C7.41059 1.88563 7.41066 1.2685 7.02352 0.88922L1.11895 6.6874ZM1.11895 6.6874C0.926085 6.49844 0.828563 6.24917 0.828563 5.99953C0.828563 5.75003 0.925913 5.5009 1.11881 5.31185L1.11885 5.31181M1.11895 6.6874L1.11885 5.31181M1.11885 5.31181L5.63369 0.889184C5.63369 0.889184 5.63369 0.889183 5.63369 0.889183M1.11885 5.31181L5.63369 0.889183M5.63369 0.889183C6.01806 0.512665 6.63917 0.512603 7.02348 0.889184L5.63369 0.889183Z"
          fill="#3EA8B8"
          stroke="#3EA8B8"
          strokeWidth="0.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_107_3021">
          <rect
            width="7"
            height="12"
            fill="white"
            transform="matrix(-1 0 0 1 7.57129 -0.000366211)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
const more_than = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="12"
      viewBox="0 0 8 12"
      fill="none"
    >
      <g clipPath="url(#clip0_107_3024)">
        <path
          d="M6.89745 6.68559L6.89743 6.6856L2.47477 11.1081C2.47476 11.1081 2.47474 11.1081 2.47473 11.1082C2.09577 11.4873 1.48127 11.4873 1.10241 11.1081C0.723651 10.7292 0.723668 10.1149 1.1025 9.73606C1.1025 9.73606 1.10251 9.73606 1.10251 9.73606L4.83913 5.99956L1.10262 2.26318L1.10258 2.26315C0.723803 1.88422 0.72374 1.26991 1.10258 0.891033L6.89745 6.68559ZM6.89745 6.68559C7.08677 6.49623 7.18161 6.24752 7.18161 5.99953C7.18161 5.75168 7.08694 5.5031 6.89759 5.31366L6.89755 5.31362M6.89745 6.68559L6.89755 5.31362M6.89755 5.31362L2.47485 0.890997C2.47485 0.890997 2.47484 0.890996 2.47484 0.890996M6.89755 5.31362L2.47484 0.890996M2.47484 0.890996C2.09591 0.512061 1.4815 0.511998 1.10261 0.890997L2.47484 0.890996Z"
          fill="#3EA8B8"
          stroke="#3EA8B8"
          strokeWidth="0.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_107_3024">
          <rect
            width="6.85714"
            height="12"
            fill="white"
            transform="translate(0.571289 -0.000366211)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
const pause = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
    >
      <g clipPath="url(#clip0_130_7081)">
        <path
          d="M4.96813 -0.000366211H3.22444C2.83412 -0.000366211 2.51758 0.316174 2.51758 0.706496V11.2927C2.51758 11.6831 2.83412 11.9996 3.22444 11.9996H4.96813C5.35845 11.9996 5.67499 11.6831 5.67499 11.2927V0.706496C5.67501 0.316174 5.35847 -0.000366211 4.96813 -0.000366211Z"
          fill="#3EA8B8"
        />
        <path
          d="M9.77477 -0.000366211H8.03108C7.64078 -0.000366211 7.32422 0.316174 7.32422 0.706496V11.2927C7.32422 11.6831 7.64076 11.9996 8.03108 11.9996H9.77477C10.1651 11.9996 10.4816 11.6831 10.4816 11.2927V0.706496C10.4816 0.316174 10.1651 -0.000366211 9.77477 -0.000366211Z"
          fill="#3EA8B8"
        />
      </g>
      <defs>
        <clipPath id="clip0_130_7081">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(0.5 -0.000366211)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
const plus = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="49"
      height="48"
      viewBox="0 0 49 48"
      fill="none"
    >
      <g filter="url(#filter0_d_107_2936)">
        <ellipse cx="24.5" cy="23.9271" rx="20" ry="19.9392" fill="#FBFBFB" />
        <path
          d="M44 23.9271C44 34.6616 35.271 43.3663 24.5 43.3663C13.729 43.3663 5 34.6616 5 23.9271C5 13.1925 13.729 4.48785 24.5 4.48785C35.271 4.48785 44 13.1925 44 23.9271Z"
          stroke="#E1F6F9"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.2005 13.9575H25.2717C25.6586 13.9575 25.9722 14.3326 25.9722 14.7954V22.4594H33.6595C34.1237 22.4594 34.5 22.772 34.5 23.1577V24.2257C34.5 24.6114 34.1237 24.924 33.6595 24.924H25.9722V33.0587C25.9722 33.5215 25.6586 33.8967 25.2717 33.8967H24.2005C23.8136 33.8967 23.5 33.5215 23.5 33.0587V24.924H15.3405C14.8763 24.924 14.5 24.6114 14.5 24.2257V23.1577C14.5 22.772 14.8763 22.4594 15.3405 22.4594H23.5V14.7954C23.5 14.3326 23.8136 13.9575 24.2005 13.9575Z"
        fill="#3EA8B8"
      />
      <defs>
        <filter
          id="filter0_d_107_2936"
          x="3.5"
          y="3.98785"
          width="42"
          height="41.8784"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_107_2936"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_107_2936"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
const plusD = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="49"
      height="48"
      viewBox="0 0 49 48"
      fill="none"
    >
      <g filter="url(#filter0_d_107_2936)">
        <ellipse cx="24.5" cy="23.9271" rx="20" ry="19.9392" fill="#FBFBFB" />
        <path
          d="M44 23.9271C44 34.6616 35.271 43.3663 24.5 43.3663C13.729 43.3663 5 34.6616 5 23.9271C5 13.1925 13.729 4.48785 24.5 4.48785C35.271 4.48785 44 13.1925 44 23.9271Z"
          stroke="#E1F6F9"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.2005 13.9575H25.2717C25.6586 13.9575 25.9722 14.3326 25.9722 14.7954V22.4594H33.6595C34.1237 22.4594 34.5 22.772 34.5 23.1577V24.2257C34.5 24.6114 34.1237 24.924 33.6595 24.924H25.9722V33.0587C25.9722 33.5215 25.6586 33.8967 25.2717 33.8967H24.2005C23.8136 33.8967 23.5 33.5215 23.5 33.0587V24.924H15.3405C14.8763 24.924 14.5 24.6114 14.5 24.2257V23.1577C14.5 22.772 14.8763 22.4594 15.3405 22.4594H23.5V14.7954C23.5 14.3326 23.8136 13.9575 24.2005 13.9575Z"
        fill="#56585D"
      />
      <defs>
        <filter
          id="filter0_d_107_2936"
          x="3.5"
          y="3.98785"
          width="42"
          height="41.8784"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_107_2936"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_107_2936"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
const minus = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="49"
      height="48"
      viewBox="0 0 49 48"
      fill="none"
    >
      <g filter="url(#filter0_d_107_2931)">
        <ellipse cx="24.5" cy="23.9271" rx="20" ry="19.9392" fill="#FBFBFB" />
        <path
          d="M44 23.9271C44 34.6616 35.271 43.3663 24.5 43.3663C13.729 43.3663 5 34.6616 5 23.9271C5 13.1925 13.729 4.48785 24.5 4.48785C35.271 4.48785 44 13.1925 44 23.9271Z"
          stroke="#E1F6F9"
        />
      </g>
      <path
        d="M14.5 23.8219L14.5 24.8899C14.5 25.2756 14.8763 25.5883 15.3405 25.5883L33.6595 25.5883C34.1237 25.5883 34.5 25.2756 34.5 24.8899L34.5 23.8219C34.5 23.4362 34.1237 23.1236 33.6595 23.1236L15.3405 23.1236C14.8763 23.1236 14.5 23.4362 14.5 23.8219Z"
        fill="#3EA8B8"
      />
      <defs>
        <filter
          id="filter0_d_107_2931"
          x="3.5"
          y="3.98785"
          width="42"
          height="41.8784"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_107_2931"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_107_2931"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
const minusD = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="49"
      height="48"
      viewBox="0 0 49 48"
      fill="none"
    >
      <g filter="url(#filter0_d_107_2931)">
        <ellipse cx="24.5" cy="23.9271" rx="20" ry="19.9392" fill="#FBFBFB" />
        <path
          d="M44 23.9271C44 34.6616 35.271 43.3663 24.5 43.3663C13.729 43.3663 5 34.6616 5 23.9271C5 13.1925 13.729 4.48785 24.5 4.48785C35.271 4.48785 44 13.1925 44 23.9271Z"
          stroke="#E1F6F9"
        />
      </g>
      <path
        d="M14.5 23.8219L14.5 24.8899C14.5 25.2756 14.8763 25.5883 15.3405 25.5883L33.6595 25.5883C34.1237 25.5883 34.5 25.2756 34.5 24.8899L34.5 23.8219C34.5 23.4362 34.1237 23.1236 33.6595 23.1236L15.3405 23.1236C14.8763 23.1236 14.5 23.4362 14.5 23.8219Z"
        fill="#56585D"
      />
      <defs>
        <filter
          id="filter0_d_107_2931"
          x="3.5"
          y="3.98785"
          width="42"
          height="41.8784"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_107_2931"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_107_2931"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
const cross = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M13.1037 11.997L18.7737 6.32471C18.8462 6.25235 18.9037 6.16639 18.9429 6.07176C18.9822 5.97713 19.0024 5.87568 19.0024 5.77324C19.0024 5.67079 18.9822 5.56934 18.9429 5.47472C18.9037 5.38009 18.8462 5.29413 18.7737 5.22176C18.6254 5.07946 18.4279 5 18.2224 5C18.017 5 17.8194 5.07946 17.6712 5.22176L12.0012 10.9028L6.33118 5.22176C6.18292 5.07946 5.9854 5 5.77993 5C5.57446 5 5.37695 5.07946 5.22868 5.22176C5.15619 5.29413 5.09868 5.38009 5.05944 5.47472C5.0202 5.56934 5 5.67079 5 5.77324C5 5.87568 5.0202 5.97713 5.05944 6.07176C5.09868 6.16639 5.15619 6.25235 5.22868 6.32471L10.8987 11.997L5.22868 17.678C5.15646 17.7497 5.09913 17.8349 5.06001 17.9288C5.02088 18.0227 5.00074 18.1234 5.00074 18.2251C5.00074 18.3269 5.02088 18.4276 5.06001 18.5215C5.09913 18.6154 5.15646 18.7006 5.22868 18.7722C5.2999 18.8462 5.38564 18.9046 5.48051 18.9437C5.57538 18.9829 5.67732 19.002 5.77993 18.9998C5.88226 19 5.98361 18.98 6.0782 18.9409C6.17278 18.9019 6.25875 18.8445 6.33118 18.7722L12.0012 13.0999L17.6712 18.7722C17.7436 18.8445 17.8296 18.9019 17.9242 18.9409C18.0188 18.98 18.1201 19 18.2224 18.9998C18.325 19.002 18.427 18.9829 18.5219 18.9437C18.6167 18.9046 18.7025 18.8462 18.7737 18.7722C18.8459 18.7006 18.9032 18.6154 18.9424 18.5215C18.9815 18.4276 19.0016 18.3269 19.0016 18.2251C19.0016 18.1234 18.9815 18.0227 18.9424 17.9288C18.9032 17.8349 18.8459 17.7497 18.7737 17.678L13.1037 11.997Z"
        fill="#56585D"
      />
    </svg>
  );
};
const door = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="fi_2520382" clipPath="url(#clip0_1218_13177)">
        <g id="_x31_636_x2C__Door_x2C__Lock_x2C__Handle_x2C_">
          <g id="Group">
            <path
              id="Vector"
              d="M22.1542 5.90001H10.7158V5.53847C10.7158 2.68383 8.39348 0.361548 5.53884 0.361548C2.68419 0.361548 0.361914 2.68383 0.361914 5.53847V18.4615C0.361914 21.3162 2.68419 23.6385 5.53884 23.6385C8.39348 23.6385 10.7158 21.3162 10.7158 18.4615V8.86924H22.1542C22.9729 8.86924 23.6388 8.20333 23.6388 7.38462C23.6388 6.56592 22.9729 5.90001 22.1542 5.90001ZM9.59268 18.4615C9.59268 20.6968 7.77404 22.5154 5.53884 22.5154C3.30363 22.5154 1.48499 20.6968 1.48499 18.4615V5.53847C1.48499 3.30327 3.30363 1.48462 5.53884 1.48462C7.77404 1.48462 9.59268 3.30327 9.59268 5.53847V5.90001H8.51993C7.9624 4.78144 6.81082 4.05386 5.53884 4.05386C3.70216 4.05386 2.20807 5.54795 2.20807 7.38462C2.20807 9.2213 3.70216 10.7154 5.53884 10.7154C6.81082 10.7154 7.9624 9.98781 8.51993 8.86924H9.59268V18.4615ZM5.53884 8.86924H7.17222C6.76177 9.3198 6.1726 9.59232 5.53884 9.59232C4.3216 9.59232 3.33114 8.60186 3.33114 7.38462C3.33114 6.16739 4.3216 5.17693 5.53884 5.17693C6.1726 5.17693 6.76177 5.44945 7.17222 5.90001H5.53884C4.72013 5.90001 4.05422 6.56592 4.05422 7.38462C4.05422 8.20333 4.72013 8.86924 5.53884 8.86924ZM22.1542 7.74616H22.1491H22.1436H22.1378H22.1316H22.1252H22.1184H22.1113H22.1039H22.0962H22.0882H22.0799H22.0712H22.0623H22.053H22.0434H22.0336H22.0234H22.0129H22.0021H21.991H21.9796H21.968H21.956H21.9437H21.9312H21.9183H21.9052H21.8917H21.878H21.864H21.8497H21.8351H21.8202H21.8051H21.7897H21.7739H21.758H21.7417H21.7251H21.7083H21.6912H21.6739H21.6562H21.6383H21.6202H21.6017H21.583H21.5641H21.5448H21.5253H21.5056H21.4856H21.4653H21.4448H21.424H21.403H21.3817H21.3601H21.3383H21.3163H21.294H21.2715H21.2487H21.2257H21.2024H21.1789H21.1551H21.1311H21.1069H21.0824H21.0578H21.0328H21.0077H20.9823H20.9566H20.9308H20.9047H20.8784H20.8518H20.8251H20.7981H20.7709H20.7435H20.7158H20.688H20.6599H20.6316H20.6031H20.5744H20.5455H20.5163H20.487H20.4574H20.4277H20.3977H20.3676H20.3372H20.3066H20.2759H20.2449H20.2137H20.1824H20.1508H20.1191H20.0871H20.055H20.0227H19.9902H19.9575H19.9246H19.8915H19.8583H19.8249H19.7912H19.7575H19.7235H19.6893H19.655H19.6205H19.5859H19.551H19.516H19.4808H19.4455H19.41H19.3743H19.3385H19.3025H19.2663H19.23H19.1935H19.1568H19.12H19.0831H19.046H19.0087H18.9713H18.9337H18.896H18.8582H18.8202H18.782H18.7437H18.7053H18.6667H18.628H18.5892H18.5502H18.511H18.4718H18.4324H18.3928H18.3532H18.3134H18.2735H18.2334H18.1933H18.153H18.1126H18.072H18.0314H17.9906H17.9497H17.9087H17.8675H17.8263H17.7849H17.7435H17.7019H17.6602H17.6184H17.5765H17.5345H17.4923H17.4501H17.4078H17.3654H17.3229H17.2803H17.2375H17.1947H17.1518H17.1088H17.0657H17.0226H16.9793H16.9359H16.8925H16.849H16.8054H16.7617H16.7179H16.674H16.6301H16.5861H16.542H16.4978H16.4536H16.4093H16.3649H16.3205H16.2759H16.2314H16.1867H16.142H16.0972H16.0524H16.0075H15.9625H15.9175H15.8724H15.8273H15.7821H15.7368H15.6915H15.6462H15.6008H15.5553H15.5099H15.4643H15.4187H15.3731H15.3274H15.2817H15.236H15.1902H15.1444H15.0985H15.0526H15.0067H14.9608H14.9148H14.8687H14.8227H14.7766H14.7305H14.6844H14.6383H14.5921H14.5459H14.4997H14.4535H14.4073H14.361H14.3147H14.2684H14.2222H14.1759H14.1295H14.0832H14.0369H13.9906H13.9442H13.8979H13.8516H13.8052H13.7589H13.7125H13.6662H13.6199H13.5736H13.5273H13.481H13.4347H13.3884H13.3421H13.2959H13.2496H13.2034H13.1572H13.111H13.0648H13.0187H12.9726H12.9265H12.8804H12.8344H12.7883H12.7424H12.6964H12.6505H12.6046H12.5587H12.5129H12.4671H12.4214H12.3757H12.33H12.2844H12.2388H12.1932H12.1477H12.1023H12.0569H12.0116H11.9663H11.921H11.8758H11.8307H11.7856H11.7406H11.6956H11.6507H11.6059H11.5611H11.5164H11.4717H11.4271H11.3826H11.3382H11.2938H11.2495H11.2052H11.1611H11.117H11.073H11.029H10.9852H10.9414H10.8977H10.8541H10.8106H10.7671H10.7238H10.6805H10.6373H10.5942H10.5512H10.5083H10.4655H10.4228H10.3802H10.3377H10.2952H10.2529H10.2107H10.1686H10.1266H10.0847H10.0429H10.0012H9.95958H9.91811H9.87675H9.8355H9.79436H9.75335H9.71245H9.67166H9.631H9.59046H9.55004H9.50974H9.46957H9.42952H9.3896H9.34981H9.31015H9.27062H9.23122H9.19196H9.15283H9.11383H9.07498H9.03626H8.99768H8.95924H8.92095H8.8828H8.84479H8.80693H8.76922H8.73165H8.69424H8.65698H8.61987H8.58291H8.54611H8.50947H8.47298H8.43665H8.40048H8.36448H8.32863H8.29295H8.25744H8.22209H8.18691H8.1519H8.11706H8.08239H8.04789H8.01357H7.97942H7.94545H7.91166H7.87805H7.84462H7.81136H7.7783H7.74541H7.71272H7.68021H7.64788H7.61575H7.58381H7.55206H7.5205H7.48914H7.45797H7.427H7.39623H7.36566H7.33529H7.30512H7.27515H7.24539H7.21584H7.18649H7.15735H7.12842H7.0997H7.07119H7.0429H7.01482H6.98696H6.95932H6.93189H6.90469H6.8777H6.85094H6.8244H6.79809H6.772H6.74614H6.72051H6.69511H6.66994H6.645H6.6203H6.59583H6.5716H6.54761H6.52385H6.50034H6.47707H6.45404H6.43125H6.40871H6.38642H6.36437H6.34258H6.32103H6.29974H6.27869H6.25791H6.23738H6.2171H6.19708H6.17733H6.15783H6.13859H6.11962H6.10092H6.08247H6.0643H6.04639H6.02876H6.01139H5.99429H5.97747H5.96093H5.94466H5.92866H5.91295H5.89751H5.88236H5.86749H5.8529H5.8386H5.82458H5.81085H5.79741H5.78425H5.77139H5.75882H5.74655H5.73457H5.72289H5.7115H5.70041H5.68962H5.67914H5.66895H5.65907H5.6495H5.64023H5.63127H5.62262H5.61428H5.60625H5.59853H5.59113H5.58404H5.57727H5.57081H5.56468H5.55887H5.55337H5.5482H5.54336H5.53884C5.33957 7.74616 5.1773 7.58389 5.1773 7.38462C5.1773 7.18536 5.33957 7.02309 5.53884 7.02309H22.1542C22.3535 7.02309 22.5158 7.18536 22.5158 7.38462C22.5158 7.58389 22.3535 7.74616 22.1542 7.74616Z"
              fill="#3AA8B8"
              stroke="#3AA8B8"
              strokeWidth="0.2"
            />
            <path
              id="Vector_2"
              d="M5.53854 13.2846C4.46534 13.2846 3.59238 14.1576 3.59238 15.2308C3.59238 16.109 4.17686 16.8528 4.977 17.0943V18.9231C4.977 19.2332 5.22839 19.4846 5.53854 19.4846C5.84868 19.4846 6.10008 19.2332 6.10008 18.9231V17.0943C6.90021 16.8528 7.48469 16.109 7.48469 15.2308C7.48469 14.1576 6.61173 13.2846 5.53854 13.2846ZM5.53854 16.0539C5.08478 16.0539 4.71546 15.6846 4.71546 15.2308C4.71546 14.777 5.08478 14.4077 5.53854 14.4077C5.99229 14.4077 6.36161 14.777 6.36161 15.2308C6.36161 15.6846 5.99229 16.0539 5.53854 16.0539Z"
              fill="#3AA8B8"
              stroke="#3AA8B8"
              strokeWidth="0.2"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1218_13177">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
const unlock = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="fi_100849" clipPath="url(#clip0_1218_13172)">
        <path
          id="Vector"
          d="M11.0475 0C8.8681 0 7.09502 1.8324 7.09502 4.08478V5.85996H0.862552C0.386209 5.85996 0 6.25904 0 6.75139V14.1086C0 14.6009 0.386209 15 0.862552 15H9.70203C10.1784 15 10.5646 14.6009 10.5646 14.1086V6.75139C10.5646 6.25904 10.1784 5.85996 9.70203 5.85996H9.23473V4.08478C9.23473 3.05177 10.0479 2.2113 11.0475 2.2113C12.0471 2.2113 12.8603 3.05171 12.8603 4.08478C12.8603 4.69543 13.3393 5.19043 13.9302 5.19043C14.521 5.19043 15 4.69543 15 4.08478C14.9999 1.83245 13.2269 0 11.0475 0ZM6.12029 10.5167V11.9779C6.12029 12.4562 5.7451 12.844 5.28229 12.844C4.81948 12.844 4.44429 12.4562 4.44429 11.9779V10.5167C4.1295 10.2602 3.92714 9.86292 3.92714 9.41651C3.92714 8.643 4.53384 8.01598 5.28229 8.01598C6.03075 8.01598 6.63745 8.643 6.63745 9.41651C6.63745 9.86292 6.43509 10.2602 6.12029 10.5167Z"
          fill="#56585D"
        />
      </g>
      <defs>
        <clipPath id="clip0_1218_13172">
          <rect width="15" height="15" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
const lock = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="fi_100893">
        <path
          id="Vector"
          d="M12.0679 5.85996H11.585V4.08478C11.5849 1.8324 9.7525 0 7.50006 0C5.24774 0 3.41534 1.8324 3.41534 4.08478V5.85996H2.93245C2.4401 5.85996 2.04102 6.25904 2.04102 6.75139V14.1086C2.04102 14.6009 2.4401 15 2.93245 15H12.0679C12.5602 15 12.9593 14.6009 12.9593 14.1086V6.75139C12.9593 6.25904 12.5602 5.85996 12.0679 5.85996ZM8.36623 10.5167V11.9779C8.36623 12.4562 7.97848 12.844 7.50017 12.844C7.02187 12.844 6.63412 12.4562 6.63412 11.9779V10.5167C6.30878 10.2602 6.09964 9.86292 6.09964 9.41651C6.09964 8.643 6.72666 8.01598 7.50017 8.01598C8.27369 8.01598 8.9007 8.643 8.9007 9.41651C8.9007 9.86292 8.69157 10.2602 8.36623 10.5167ZM9.37359 5.77703H5.62665V4.08478C5.62665 3.05171 6.46705 2.2113 7.50012 2.2113C8.53319 2.2113 9.37365 3.05171 9.37365 4.08478V5.77703H9.37359Z"
          fill="#56585D"
        />
      </g>
    </svg>
  );
};
const motionseneor = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <rect x="0.5" y="0.5" width="23" height="23" rx="3.5" stroke="#3AA8B8" />
      <path
        d="M15.3555 3.75C15.7726 4.7402 17.2267 4.7397 17.6435 3.75H15.3555Z"
        fill="#3AA8B8"
      />
      <path
        d="M19.5003 1C18.8266 1 14.1745 1 13.5003 1C13.1726 1.00527 13.171 1.49437 13.5003 1.5H13.7503V2.75C13.7503 3.16357 14.0867 3.5 14.5003 3.5H18.5003C18.9138 3.5 19.2503 3.16357 19.2503 2.75V1.5H19.5003C19.8289 1.49442 19.8288 1.00552 19.5003 1ZM15.5003 2.5C15.1717 2.49443 15.1717 2.00552 15.5003 2C15.8289 2.00557 15.8288 2.49448 15.5003 2.5ZM16.5003 2.5C16.1717 2.49443 16.1717 2.00552 16.5003 2C16.8289 2.00557 16.8288 2.49448 16.5003 2.5ZM17.5003 2.5C17.1717 2.49443 17.1717 2.00552 17.5003 2C17.8289 2.00557 17.8288 2.49448 17.5003 2.5Z"
        fill="#3AA8B8"
      />
      <path
        d="M16.5414 5.49943C15.7123 5.51198 14.8096 4.99573 14.4898 4.26308C14.4321 4.13773 14.4868 3.98928 14.6122 3.93143C14.7372 3.87345 14.886 3.92838 14.9439 4.05385C15.1235 4.44325 15.4944 4.7538 15.9619 4.90565C16.4293 5.0575 16.9122 5.02443 17.2861 4.81483C17.4069 4.74768 17.5589 4.7904 17.6264 4.91078C17.8364 5.3704 16.8547 5.49598 16.5414 5.49943Z"
        fill="#3AA8B8"
      />
      <path
        d="M16.5477 6.49998C15.3508 6.51703 14.0753 5.7781 13.5991 4.7192C13.5402 4.59435 13.5938 4.4453 13.7187 4.38645C13.8433 4.32773 13.9926 4.3812 14.0515 4.50608C14.3447 5.12863 14.9284 5.62058 15.6529 5.85605C16.3777 6.0914 17.1393 6.0366 17.7422 5.70543C17.8634 5.63915 18.0151 5.68308 18.0816 5.80418C18.3321 6.30945 16.89 6.51275 16.5477 6.49998Z"
        fill="#3AA8B8"
      />
      <path
        d="M16.5459 7.49905C14.9805 7.51972 13.3537 6.563 12.7085 5.17567C12.6485 5.05142 12.7006 4.9019 12.825 4.84195C12.9493 4.78177 13.0987 4.83402 13.1587 4.9584C13.5732 5.81667 14.3697 6.49037 15.3439 6.80702C16.3182 7.12317 17.3586 7.0464 18.1984 6.59585C18.3201 6.5303 18.4717 6.57595 18.5369 6.69777C18.6022 6.81947 18.5566 6.97097 18.435 7.03627C17.8633 7.34315 17.2123 7.49905 16.5459 7.49905Z"
        fill="#3AA8B8"
      />
      <path
        d="M14.2498 9.25C14.2498 10.0784 13.5782 10.75 12.7498 10.75C10.7641 10.6814 10.7646 7.8183 12.7498 7.75C13.5782 7.75 14.2498 8.42158 14.2498 9.25Z"
        fill="#3AA8B8"
      />
      <path
        d="M16.1146 14.0644L18.5902 13.5009C18.9279 13.4246 19.1356 13.0824 19.0492 12.7475C18.9702 12.4051 18.6309 12.1939 18.2919 12.2737C17.4174 12.4796 15.917 12.826 15.917 12.826L10.5056 10.4292C10.3136 10.3441 10.1033 10.3088 9.89406 10.3265L7.03846 10.5679C6.81509 10.5868 6.60449 10.68 6.44024 10.8325L4.57836 12.5618C3.98874 13.141 4.84279 14.0186 5.44846 13.4708C6.10361 12.8565 7.23144 11.8048 7.23144 11.8048L9.60801 11.5969C9.57229 11.7056 7.64516 15.7187 7.74146 15.6937L7.05294 18.7328L5.69689 20.5624C5.05919 21.5229 6.44399 22.4955 7.13041 21.5662L8.56561 19.6138C8.66041 19.4848 8.72956 19.3389 8.76931 19.1838L9.22719 17.3976L10.231 20.1176V22.1249C10.2664 23.2808 11.9453 23.2818 11.981 22.1249V20.0735C12.0274 19.7776 11.0337 16.8404 10.955 16.4899L12.8568 12.9116L15.4668 13.9952C15.669 14.0895 15.897 14.1139 16.1146 14.0644Z"
        fill="#3AA8B8"
      />
    </svg>
  );
};
const freshair = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M22.3875 4.39683C22.2851 3.75363 21.7219 3.27363 21.0723 3.27363C21.0691 3.27363 21.0627 3.27363 21.0595 3.27363C17.0211 3.31523 13.1267 4.75523 10.0323 7.33443C9.93627 6.20163 9.61307 5.09763 9.07867 4.08643C8.34907 2.70723 7.25147 1.55523 5.91067 0.755231C5.36987 0.432031 4.69467 0.521631 4.27227 0.972831C2.26267 3.11363 1.18107 5.91043 1.22907 8.84803C1.27387 11.6768 2.36187 14.3392 4.30107 16.384C4.11867 17.0816 3.98107 17.792 3.88827 18.5152C3.84987 18.8128 4.05787 19.0848 4.35867 19.1264C4.38107 19.1296 4.40667 19.1296 4.42907 19.1296C4.69787 19.1296 4.93147 18.9312 4.96667 18.656C5.06587 17.904 5.21307 17.168 5.41147 16.4544C5.43387 16.4064 5.44667 16.3584 5.45307 16.3072C7.41467 9.43043 13.7571 4.43843 21.0787 4.36163C21.0787 4.36163 21.0787 4.36163 21.0819 4.36163C21.1971 4.36163 21.3059 4.45443 21.3251 4.56643C21.7283 7.11043 21.7411 9.68963 21.3635 12.2368C21.3571 12.256 21.3507 12.2752 21.3475 12.2944C20.5955 15.5232 18.4963 18.2816 15.5811 19.8592C13.0115 21.2544 10.0195 21.6192 7.21307 20.912C8.16027 20.288 9.06907 19.6032 9.93627 18.8576C12.2243 16.8896 14.1475 14.5632 15.6515 11.9488C15.8019 11.6896 15.7123 11.3568 15.4499 11.2064C15.1907 11.056 14.8579 11.1456 14.7075 11.408C12.5123 15.2 9.37307 18.368 5.64187 20.6016C5.62587 20.608 5.61307 20.6176 5.59707 20.6272C4.40027 21.3408 3.14587 21.9552 1.84027 22.4672C1.56187 22.576 1.42107 22.8928 1.53307 23.1712C1.61627 23.3856 1.82107 23.5168 2.03867 23.5168C2.10587 23.5168 2.17307 23.504 2.23707 23.4784C3.52987 22.9728 4.77147 22.3712 5.96187 21.6768C7.28667 22.1248 8.66267 22.3488 10.0355 22.3488C12.1283 22.3488 14.2115 21.8336 16.0867 20.8128C19.2419 19.104 21.5267 16.128 22.3683 12.6432C22.3875 12.5984 22.4035 12.5504 22.4099 12.4992C22.8227 9.81123 22.8131 7.08483 22.3875 4.39683ZM6.69147 11.04C6.68507 10.4576 6.65947 9.91683 6.61467 9.39843C6.51547 8.29123 6.32667 7.12643 6.03867 5.83043C5.97467 5.53603 5.68347 5.35363 5.38907 5.41763C5.09467 5.48163 4.91227 5.77283 4.97627 6.06723C5.25467 7.31523 5.43707 8.43523 5.52987 9.49443C5.61947 10.5088 5.62907 11.6256 5.55547 12.9984C5.20987 13.696 4.90907 14.416 4.65947 15.1584C1.38267 11.248 1.49467 5.51043 5.05947 1.71523C5.12987 1.63843 5.25147 1.62883 5.35067 1.68643C7.68347 3.07523 9.05627 5.59043 8.96987 8.29123C8.11227 9.13283 7.35067 10.0544 6.69147 11.04Z"
        fill="#3AA8B8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 2.93333C11.5155 2.93333 11.9333 2.51547 11.9333 2C11.9333 1.48453 11.5155 1.06667 11 1.06667C10.4845 1.06667 10.0667 1.48453 10.0667 2C10.0667 2.51547 10.4845 2.93333 11 2.93333ZM11 4C12.1046 4 13 3.10457 13 2C13 0.895431 12.1046 0 11 0C9.89543 0 9 0.895431 9 2C9 3.10457 9.89543 4 11 4Z"
        fill="#3AA8B8"
      />
      <path
        d="M13.2414 3.53044L13.2781 3.55737L13.3084 3.5234C13.4272 3.39008 13.5001 3.34155 13.6023 3.34155C13.6577 3.34155 13.6996 3.35625 13.7267 3.37915C13.7528 3.40112 13.7701 3.43456 13.7701 3.4838C13.7701 3.53172 13.7556 3.57148 13.7169 3.61836C13.6763 3.66763 13.6107 3.72254 13.5097 3.79875C13.5097 3.79878 13.5097 3.7988 13.5096 3.79882L12.9701 4.20221L12.95 4.2172V4.24225V4.5V4.55H13H14.2H14.25V4.5V4.21901V4.16901H14.2H13.6513L13.7863 4.07398L13.7864 4.07394C13.9295 3.97288 14.0416 3.88739 14.1173 3.79384C14.1951 3.69751 14.2338 3.59345 14.2338 3.45845C14.2338 3.30619 14.1746 3.1771 14.066 3.08696C13.9583 2.99762 13.8064 2.95 13.6255 2.95C13.4741 2.95 13.3543 2.97826 13.2506 3.03479C13.1474 3.09101 13.0638 3.17322 12.9819 3.27499L12.9491 3.31569L12.9912 3.34663L13.2414 3.53044Z"
        fill="#3AA8B8"
        stroke="#3AA8B8"
        strokeWidth="0.1"
      />
    </svg>
  );
};
const freshairOff = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M22.3875 4.39683C22.2851 3.75363 21.7219 3.27363 21.0723 3.27363C21.0691 3.27363 21.0627 3.27363 21.0595 3.27363C17.0211 3.31523 13.1267 4.75523 10.0323 7.33443C9.93627 6.20163 9.61307 5.09763 9.07867 4.08643C8.34907 2.70723 7.25147 1.55523 5.91067 0.755231C5.36987 0.432031 4.69467 0.521631 4.27227 0.972831C2.26267 3.11363 1.18107 5.91043 1.22907 8.84803C1.27387 11.6768 2.36187 14.3392 4.30107 16.384C4.11867 17.0816 3.98107 17.792 3.88827 18.5152C3.84987 18.8128 4.05787 19.0848 4.35867 19.1264C4.38107 19.1296 4.40667 19.1296 4.42907 19.1296C4.69787 19.1296 4.93147 18.9312 4.96667 18.656C5.06587 17.904 5.21307 17.168 5.41147 16.4544C5.43387 16.4064 5.44667 16.3584 5.45307 16.3072C7.41467 9.43043 13.7571 4.43843 21.0787 4.36163C21.0787 4.36163 21.0787 4.36163 21.0819 4.36163C21.1971 4.36163 21.3059 4.45443 21.3251 4.56643C21.7283 7.11043 21.7411 9.68963 21.3635 12.2368C21.3571 12.256 21.3507 12.2752 21.3475 12.2944C20.5955 15.5232 18.4963 18.2816 15.5811 19.8592C13.0115 21.2544 10.0195 21.6192 7.21307 20.912C8.16027 20.288 9.06907 19.6032 9.93627 18.8576C12.2243 16.8896 14.1475 14.5632 15.6515 11.9488C15.8019 11.6896 15.7123 11.3568 15.4499 11.2064C15.1907 11.056 14.8579 11.1456 14.7075 11.408C12.5123 15.2 9.37307 18.368 5.64187 20.6016C5.62587 20.608 5.61307 20.6176 5.59707 20.6272C4.40027 21.3408 3.14587 21.9552 1.84027 22.4672C1.56187 22.576 1.42107 22.8928 1.53307 23.1712C1.61627 23.3856 1.82107 23.5168 2.03867 23.5168C2.10587 23.5168 2.17307 23.504 2.23707 23.4784C3.52987 22.9728 4.77147 22.3712 5.96187 21.6768C7.28667 22.1248 8.66267 22.3488 10.0355 22.3488C12.1283 22.3488 14.2115 21.8336 16.0867 20.8128C19.2419 19.104 21.5267 16.128 22.3683 12.6432C22.3875 12.5984 22.4035 12.5504 22.4099 12.4992C22.8227 9.81123 22.8131 7.08483 22.3875 4.39683ZM6.69147 11.04C6.68507 10.4576 6.65947 9.91683 6.61467 9.39843C6.51547 8.29123 6.32667 7.12643 6.03867 5.83043C5.97467 5.53603 5.68347 5.35363 5.38907 5.41763C5.09467 5.48163 4.91227 5.77283 4.97627 6.06723C5.25467 7.31523 5.43707 8.43523 5.52987 9.49443C5.61947 10.5088 5.62907 11.6256 5.55547 12.9984C5.20987 13.696 4.90907 14.416 4.65947 15.1584C1.38267 11.248 1.49467 5.51043 5.05947 1.71523C5.12987 1.63843 5.25147 1.62883 5.35067 1.68643C7.68347 3.07523 9.05627 5.59043 8.96987 8.29123C8.11227 9.13283 7.35067 10.0544 6.69147 11.04Z"
        fill="#56585D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 2.93333C11.5155 2.93333 11.9333 2.51547 11.9333 2C11.9333 1.48453 11.5155 1.06667 11 1.06667C10.4845 1.06667 10.0667 1.48453 10.0667 2C10.0667 2.51547 10.4845 2.93333 11 2.93333ZM11 4C12.1046 4 13 3.10457 13 2C13 0.895431 12.1046 0 11 0C9.89543 0 9 0.895431 9 2C9 3.10457 9.89543 4 11 4Z"
        fill="#56585D"
      />
      <path
        d="M13.2414 3.53044L13.2781 3.55737L13.3084 3.5234C13.4272 3.39008 13.5001 3.34155 13.6023 3.34155C13.6577 3.34155 13.6996 3.35625 13.7267 3.37915C13.7528 3.40112 13.7701 3.43456 13.7701 3.4838C13.7701 3.53172 13.7556 3.57148 13.7169 3.61836C13.6763 3.66763 13.6107 3.72254 13.5097 3.79875C13.5097 3.79878 13.5097 3.7988 13.5096 3.79882L12.9701 4.20221L12.95 4.2172V4.24225V4.5V4.55H13H14.2H14.25V4.5V4.21901V4.16901H14.2H13.6513L13.7863 4.07398L13.7864 4.07394C13.9295 3.97288 14.0416 3.88739 14.1173 3.79384C14.1951 3.69751 14.2338 3.59345 14.2338 3.45845C14.2338 3.30619 14.1746 3.1771 14.066 3.08696C13.9583 2.99762 13.8064 2.95 13.6255 2.95C13.4741 2.95 13.3543 2.97826 13.2506 3.03479C13.1474 3.09101 13.0638 3.17322 12.9819 3.27499L12.9491 3.31569L12.9912 3.34663L13.2414 3.53044Z"
        fill="#56585D"
        stroke="#56585D"
        strokeWidth="0.1"
      />
    </svg>
  );
};
const heat = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1365_11911)">
        <path
          d="M19.414 18.8281H18.8281V7.91089L19.0634 8.08667C19.3243 8.28159 19.6911 8.22542 19.8835 7.96784C20.0771 7.70859 20.0239 7.3414 19.7646 7.14777C19.7298 7.12163 17.1143 5.16828 10.3506 0.116545C10.1427 -0.0387669 9.85728 -0.0387669 9.64939 0.116545C9.45315 0.263146 0.657319 6.83261 0.235367 7.14777C-0.0239287 7.3414 -0.0771317 7.70855 0.116539 7.96784C0.310133 8.2271 0.67728 8.28034 0.936575 8.08667L1.17189 7.91089V18.8281H0.585952C0.262359 18.8281 1.64803e-05 19.0905 1.64803e-05 19.414C1.64803e-05 19.7376 0.262359 20 0.585952 20H19.414C19.7376 20 19.9999 19.7376 19.9999 19.414C19.9999 19.0905 19.7376 18.8281 19.414 18.8281ZM2.3438 7.03566L10 1.31732L17.6562 7.03566V18.8281H2.3438V7.03566Z"
          fill="#56585D"
        />
        <path
          d="M15.2729 11.1328C15.2729 9.70861 14.7139 8.37393 13.6988 7.37468C13.4682 7.14761 13.0972 7.15061 12.8702 7.3812C12.6432 7.61182 12.6461 7.9828 12.8767 8.20979C13.6662 8.98701 14.101 10.0251 14.101 11.1328C14.101 13.367 12.3055 15.1894 10.0817 15.2333L10.4138 14.9012C10.6426 14.6724 10.6426 14.3014 10.4138 14.0726C10.185 13.8438 9.81398 13.8438 9.58515 14.0726L8.41328 15.2445C8.1648 15.4929 8.18477 15.9198 8.46769 16.1369L9.55933 17.379C9.77269 17.6217 10.1428 17.6462 10.3863 17.4323C10.6294 17.2187 10.6532 16.8484 10.4396 16.6054L10.2589 16.3998C13.0467 16.2641 15.2729 13.9536 15.2729 11.1328Z"
          fill="#56585D"
        />
        <path
          d="M5.89847 11.1328C5.89847 8.90292 7.68714 7.08312 9.90506 7.03245L9.58568 7.35183C9.35686 7.58065 9.35686 7.95163 9.58568 8.18046C9.81447 8.40925 10.1855 8.40928 10.4143 8.18046L11.5862 7.00859C11.8099 6.78499 11.8168 6.42 11.5946 6.18785L10.4383 4.88457C10.2235 4.64254 9.85326 4.62035 9.61111 4.83516C9.36904 5.04992 9.3469 5.42027 9.56166 5.66234L9.74217 5.86578C6.95366 6.0007 4.72656 8.31151 4.72656 11.1328C4.72656 12.5533 5.28304 13.8855 6.29351 14.8839C6.52253 15.1103 6.89355 15.1103 7.12214 14.879C7.34956 14.6488 7.34737 14.2779 7.11718 14.0504C6.33128 13.2737 5.89847 12.2376 5.89847 11.1328Z"
          fill="#56585D"
        />
      </g>
      <defs>
        <clipPath id="clip0_1365_11911">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
const vent = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1365_11902)">
        <path
          d="M16.0312 19.0626H15.5625V10.3287L15.7507 10.4694C15.9595 10.6253 16.2529 10.5804 16.4068 10.3743C16.5617 10.1669 16.5191 9.87316 16.3117 9.71825C16.2838 9.69734 14.1915 8.13465 8.78048 4.09325C8.61417 3.969 8.38583 3.969 8.21952 4.09325C8.06252 4.21053 1.02586 9.46612 0.688294 9.71825C0.480857 9.87316 0.438295 10.1669 0.593232 10.3743C0.748106 10.5817 1.04182 10.6243 1.24926 10.4694L1.43751 10.3287V19.0626H0.968761C0.709887 19.0626 0.500013 19.2724 0.500013 19.5313C0.500013 19.7902 0.709887 20.0001 0.968761 20.0001H16.0312C16.2901 20.0001 16.5 19.7902 16.5 19.5313C16.5 19.2724 16.2901 19.0626 16.0312 19.0626ZM2.37504 9.62856L8.50002 5.05387L14.625 9.62856V19.0626H2.37504V9.62856Z"
          fill="#56585D"
        />
        <path
          d="M6.93234 7.41795C6.89452 7.35114 6.87033 7.27722 6.86115 7.20041C6.85197 7.12361 6.85798 7.04541 6.87883 6.9703C6.89969 6.89518 6.93499 6.82461 6.9827 6.76263C7.03042 6.70064 7.08963 6.64845 7.15694 6.60904C8.47023 5.8399 8.63451 5.33977 8.86101 4.64818C9.05875 4.04521 9.29448 3.32613 10.1878 2.40499L9.62984 2.47262C9.55302 2.48194 9.47544 2.47599 9.40154 2.45512C9.32765 2.43426 9.25887 2.39888 9.19915 2.35102C9.13942 2.30315 9.08992 2.24373 9.05346 2.17615C9.017 2.10857 8.9943 2.03415 8.98666 1.95714C8.97902 1.88014 8.98659 1.80205 9.00893 1.72734C9.03127 1.65263 9.06794 1.58276 9.11686 1.52173C9.16578 1.46069 9.22598 1.40968 9.29403 1.3716C9.36209 1.33353 9.43665 1.30914 9.51348 1.29983L11.5527 1.05274C11.6295 1.04343 11.7071 1.04936 11.781 1.07023C11.8549 1.09109 11.9237 1.12647 11.9834 1.17434C12.0431 1.22221 12.0926 1.28163 12.1291 1.34921C12.1655 1.41679 12.1882 1.49121 12.1959 1.56822L12.3986 3.61246C12.414 3.76798 12.3672 3.92461 12.2684 4.04788C12.1696 4.17115 12.0269 4.25097 11.8718 4.26978C11.7166 4.28858 11.5617 4.24484 11.4411 4.14817C11.3205 4.0515 11.244 3.90982 11.2286 3.75429L11.1616 3.07904C10.3465 3.86974 10.159 4.44066 9.97691 4.99654C9.71429 5.79723 9.44282 6.62506 7.73268 7.6267C7.66537 7.66613 7.59127 7.69201 7.51461 7.70286C7.43796 7.71372 7.36024 7.70934 7.28591 7.68997C7.21157 7.67061 7.14207 7.63663 7.08138 7.58999C7.02069 7.54335 6.97015 7.48476 6.93234 7.41795Z"
          fill="#56585D"
        />
        <path
          d="M10.4734 10.2568C10.4355 10.19 10.4113 10.1161 10.4022 10.0393C10.393 9.96247 10.399 9.88428 10.4198 9.80916C10.4407 9.73405 10.476 9.66348 10.5237 9.6015C10.5714 9.53951 10.6306 9.48732 10.698 9.44791C12.0112 8.67877 12.1755 8.17864 12.402 7.48705C12.5998 6.88408 12.8355 6.165 13.7288 5.24386L13.1709 5.31149C13.094 5.3208 13.0165 5.31486 12.9426 5.29399C12.8687 5.27313 12.7999 5.23775 12.7402 5.18988C12.6804 5.14202 12.6309 5.0826 12.5945 5.01501C12.558 4.94743 12.5353 4.87302 12.5277 4.79601C12.52 4.719 12.5276 4.64092 12.5499 4.56621C12.5723 4.4915 12.609 4.42163 12.6579 4.36059C12.7068 4.29956 12.767 4.24854 12.835 4.21047C12.9031 4.1724 12.9777 4.14801 13.0545 4.13869L15.0937 3.89161C15.1705 3.88229 15.2481 3.88823 15.322 3.9091C15.3959 3.92996 15.4647 3.96534 15.5244 4.01321C15.5841 4.06107 15.6336 4.12049 15.6701 4.18808C15.7066 4.25566 15.7293 4.33008 15.7369 4.40709L15.9396 6.45133C15.955 6.60685 15.9082 6.76347 15.8094 6.88674C15.7106 7.01001 15.5679 7.08983 15.4128 7.10864C15.2576 7.12745 15.1027 7.08371 14.9821 6.98703C14.8615 6.89036 14.785 6.74868 14.7696 6.59316L14.7026 5.91791C13.8875 6.7086 13.7 7.27953 13.5179 7.83541C13.2553 8.63609 12.9838 9.46393 11.2737 10.4656C11.2064 10.505 11.1323 10.5309 11.0556 10.5417C10.979 10.5526 10.9013 10.5482 10.8269 10.5288C10.7526 10.5095 10.6831 10.4755 10.6224 10.4289C10.5617 10.3822 10.5112 10.3236 10.4734 10.2568Z"
          fill="#56585D"
        />
        <path
          d="M14.0163 13.0957C13.9785 13.0289 13.9543 12.955 13.9451 12.8781C13.936 12.8013 13.942 12.7231 13.9628 12.648C13.9837 12.5729 14.019 12.5023 14.0667 12.4404C14.1144 12.3784 14.1736 12.3262 14.2409 12.2868C15.5542 11.5176 15.7185 11.0175 15.945 10.3259C16.1427 9.72294 16.3785 9.00386 17.2718 8.08273L16.7138 8.15036C16.637 8.15967 16.5594 8.15372 16.4855 8.13286C16.4116 8.11199 16.3429 8.07662 16.2831 8.02875C16.2234 7.98088 16.1739 7.92146 16.1374 7.85388C16.101 7.7863 16.0783 7.71188 16.0706 7.63488C16.063 7.55787 16.0706 7.47978 16.0929 7.40507C16.1153 7.33036 16.1519 7.2605 16.2008 7.19946C16.2498 7.13842 16.31 7.08741 16.378 7.04934C16.4461 7.01126 16.5206 6.98687 16.5975 6.97756L18.6367 6.73048C18.7135 6.72116 18.7911 6.7271 18.865 6.74796C18.9389 6.76883 19.0077 6.8042 19.0674 6.85207C19.1271 6.89994 19.1766 6.95936 19.2131 7.02694C19.2495 7.09453 19.2722 7.16895 19.2799 7.24596L19.4826 9.29019C19.498 9.44572 19.4512 9.60234 19.3524 9.72561C19.2536 9.84888 19.1109 9.9287 18.9558 9.94751C18.8006 9.96632 18.6457 9.92257 18.5251 9.8259C18.4044 9.72923 18.328 9.58755 18.3126 9.43203L18.2456 8.75678C17.4305 9.54747 17.243 10.1184 17.0609 10.6743C16.7983 11.475 16.5268 12.3028 14.8167 13.3044C14.7494 13.3439 14.6753 13.3697 14.5986 13.3806C14.5219 13.3915 14.4442 13.3871 14.3699 13.3677C14.2956 13.3483 14.2261 13.3144 14.1654 13.2677C14.1047 13.2211 14.0541 13.1625 14.0163 13.0957Z"
          fill="#56585D"
        />
      </g>
      <defs>
        <clipPath id="clip0_1365_11902">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
const supply = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1365_11892)">
        <path
          d="M15.5312 19.0626H15.0625V10.3287L15.2507 10.4694C15.4595 10.6253 15.7529 10.5804 15.9068 10.3743C16.0617 10.1669 16.0191 9.87316 15.8117 9.71825C15.7838 9.69734 13.6915 8.13465 8.28048 4.09325C8.11417 3.969 7.88583 3.969 7.71952 4.09325C7.56252 4.21053 0.525855 9.46612 0.188294 9.71825C-0.019143 9.87316 -0.0617054 10.1669 0.0932316 10.3743C0.248106 10.5817 0.541824 10.6243 0.74926 10.4694L0.93751 10.3287V19.0626H0.468761C0.209887 19.0626 1.31811e-05 19.2724 1.31811e-05 19.5313C1.31811e-05 19.7902 0.209887 20.0001 0.468761 20.0001H15.5312C15.7901 20.0001 16 19.7902 16 19.5313C16 19.2724 15.7901 19.0626 15.5312 19.0626ZM1.87504 9.62856L8.00002 5.05387L14.125 9.62856V19.0626H1.87504V9.62856Z"
          fill="#56585D"
        />
        <path
          d="M18.596 8.21813C18.6277 8.2917 18.6444 8.37107 18.6453 8.45168C18.6461 8.5323 18.6311 8.61259 18.6011 8.68798C18.571 8.76336 18.5265 8.83237 18.4701 8.89104C18.4137 8.94971 18.3464 8.99691 18.2723 9.02993C16.825 9.67445 16.5985 10.1734 16.286 10.8635C16.0133 11.4651 15.6882 12.1826 14.659 13.0332L15.2447 13.0278C15.3253 13.027 15.405 13.0422 15.4793 13.0723C15.5535 13.1025 15.6208 13.1471 15.6773 13.2036C15.7338 13.2601 15.7784 13.3274 15.8085 13.4016C15.8387 13.4758 15.8538 13.5555 15.8531 13.6362C15.8524 13.7168 15.8357 13.7968 15.8042 13.8716C15.7726 13.9464 15.7268 14.0145 15.6692 14.0721C15.6117 14.1296 15.5435 14.1755 15.4688 14.207C15.394 14.2386 15.314 14.2552 15.2333 14.256L13.0927 14.2757C13.012 14.2764 12.9323 14.2613 12.8581 14.2311C12.7839 14.2009 12.7166 14.1563 12.6601 14.0998C12.6036 14.0433 12.559 13.9761 12.5288 13.9018C12.4986 13.8276 12.4835 13.7479 12.4843 13.6673L12.5042 11.5265C12.5057 11.3636 12.5719 11.2068 12.6881 11.0906C12.8043 10.9743 12.9611 10.9082 13.124 10.9067C13.2869 10.9052 13.4425 10.9684 13.5566 11.0825C13.6707 11.1966 13.7339 11.3522 13.7324 11.5151L13.7259 12.2222C14.6593 11.4977 14.9179 10.9281 15.1691 10.3734C15.5312 9.57454 15.9056 8.74856 17.7902 7.90921C17.8644 7.87617 17.9441 7.85795 18.0247 7.85558C18.1054 7.85322 18.1854 7.86676 18.2603 7.89543C18.3351 7.9241 18.4033 7.96734 18.4609 8.02267C18.5186 8.07801 18.5643 8.14455 18.596 8.21813Z"
          fill="#56585D"
        />
        <path
          d="M15.262 4.88317C15.2937 4.95674 15.3104 5.03611 15.3113 5.11672C15.3122 5.19734 15.2971 5.27763 15.2671 5.35302C15.237 5.4284 15.1925 5.4974 15.1361 5.55608C15.0797 5.61475 15.0125 5.66195 14.9383 5.69497C13.491 6.33948 13.2645 6.83846 12.9521 7.52853C12.6793 8.13015 12.3542 8.84763 11.325 9.69822L11.9107 9.69279C11.9914 9.69205 12.0711 9.70719 12.1453 9.73736C12.2195 9.76753 12.2868 9.81214 12.3433 9.86864C12.3998 9.92513 12.4444 9.99241 12.4745 10.0666C12.5047 10.1409 12.5199 10.2206 12.5191 10.3012C12.5184 10.3818 12.5017 10.4618 12.4702 10.5366C12.4386 10.6114 12.3928 10.6795 12.3352 10.7371C12.2777 10.7947 12.2096 10.8405 12.1348 10.8721C12.06 10.9036 11.98 10.9202 11.8993 10.921L9.75867 10.9407C9.67803 10.9415 9.59832 10.9263 9.5241 10.8961C9.44987 10.866 9.3826 10.8214 9.3261 10.7649C9.2696 10.7084 9.22499 10.6411 9.19482 10.5669C9.16465 10.4926 9.14951 10.4129 9.15027 10.3323L9.17023 8.19151C9.17173 8.02864 9.23788 7.87185 9.35411 7.75561C9.47035 7.63938 9.62715 7.57323 9.79001 7.57172C9.95288 7.57021 10.1085 7.63347 10.2226 7.74757C10.3367 7.86166 10.3999 8.01726 10.3984 8.18013L10.3919 8.88727C11.3254 8.16274 11.5839 7.59312 11.8351 7.03847C12.1973 6.23958 12.5717 5.4136 14.4562 4.57425C14.5304 4.54121 14.6101 4.52299 14.6908 4.52062C14.7714 4.51826 14.8514 4.5318 14.9263 4.56047C15.0011 4.58914 15.0693 4.63237 15.1269 4.68771C15.1846 4.74305 15.2303 4.80959 15.262 4.88317Z"
          fill="#56585D"
        />
        <path
          d="M11.9261 1.54821C11.9577 1.62178 11.9745 1.70115 11.9753 1.78176C11.9762 1.86238 11.9612 1.94267 11.9311 2.01806C11.9011 2.09344 11.8566 2.16244 11.8001 2.22112C11.7437 2.27979 11.6765 2.32698 11.6023 2.36001C10.1551 3.00452 9.92861 3.5035 9.61612 4.19357C9.34341 4.79519 9.01826 5.51267 7.98908 6.36326L8.57477 6.35783C8.65542 6.35709 8.73512 6.37223 8.80934 6.4024C8.88356 6.43257 8.95084 6.47718 9.00734 6.53368C9.06383 6.59017 9.10844 6.65745 9.13861 6.73167C9.16878 6.80589 9.18393 6.88559 9.18318 6.96624C9.18243 7.04688 9.16581 7.12689 9.13426 7.20168C9.1027 7.27647 9.05684 7.34459 8.99929 7.40214C8.94174 7.45969 8.87362 7.50555 8.79883 7.5371C8.72404 7.56866 8.64403 7.58528 8.56339 7.58603L6.42273 7.60574C6.34209 7.60649 6.26238 7.59135 6.18816 7.56118C6.11394 7.53101 6.04666 7.4864 5.99016 7.42991C5.93366 7.37341 5.88906 7.30613 5.85889 7.23191C5.82872 7.15769 5.81358 7.07798 5.81433 6.99733L5.83429 4.85655C5.8358 4.69368 5.90194 4.53688 6.01818 4.42065C6.13441 4.30442 6.29121 4.23827 6.45408 4.23676C6.61695 4.23525 6.77254 4.29851 6.88664 4.4126C7.00074 4.5267 7.06399 4.6823 7.06248 4.84517L7.05593 5.55231C7.98942 4.82777 8.24794 4.25816 8.49913 3.70351C8.86132 2.90462 9.23572 2.07864 11.1203 1.23929C11.1945 1.20625 11.2742 1.18803 11.3548 1.18566C11.4355 1.1833 11.5155 1.19684 11.5903 1.22551C11.6652 1.25418 11.7334 1.29741 11.791 1.35275C11.8486 1.40809 11.8944 1.47463 11.9261 1.54821Z"
          fill="#56585D"
        />
      </g>
      <defs>
        <clipPath id="clip0_1365_11892">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
const doorcontactsensor = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1365_11855)">
        <path
          d="M23.8133 17.79C23.2882 17.1589 22.6307 16.651 21.8873 16.3024C21.144 15.9539 20.333 15.7732 19.512 15.7732C18.691 15.7732 17.8801 15.9539 17.1367 16.3024C16.3934 16.651 15.7358 17.1589 15.2108 17.79C15.0877 17.9545 15.0324 18.1599 15.0562 18.3639C15.08 18.5679 15.1812 18.755 15.3388 18.8867C15.4964 19.0184 15.6986 19.0846 15.9036 19.0718C16.1086 19.0589 16.3008 18.9679 16.4408 18.8175C16.8159 18.3672 17.2855 18.0049 17.8163 17.7563C18.347 17.5077 18.9259 17.3788 19.512 17.3788C20.0981 17.3788 20.677 17.5077 21.2078 17.7563C21.7385 18.0049 22.2081 18.3672 22.5833 18.8175C22.6486 18.9048 22.731 18.9778 22.8254 19.0322C22.9199 19.0866 23.0245 19.1212 23.1327 19.1338C23.241 19.1464 23.3507 19.1369 23.4552 19.1057C23.5596 19.0746 23.6566 19.0225 23.7403 18.9526C23.8239 18.8827 23.8925 18.7965 23.9417 18.6993C23.991 18.602 24.0199 18.4958 24.0267 18.387C24.0335 18.2782 24.0181 18.1692 23.9814 18.0665C23.9447 17.9639 23.8875 17.8698 23.8133 17.79Z"
          fill="#3AA8B8"
        />
        <path
          d="M19.5006 18.975C18.9137 18.9741 18.3338 19.1027 17.8023 19.3516C17.2708 19.6005 16.8007 19.9636 16.4256 20.415C16.3025 20.5794 16.2472 20.7848 16.271 20.9888C16.2949 21.1929 16.396 21.38 16.5536 21.5117C16.7113 21.6434 16.9134 21.7096 17.1184 21.6967C17.3234 21.6838 17.5157 21.5929 17.6556 21.4425C17.8808 21.1718 18.1629 20.9539 18.4817 20.8044C18.8006 20.6549 19.1484 20.5774 19.5006 20.5774C19.8528 20.5774 20.2006 20.6549 20.5195 20.8044C20.8383 20.9539 21.1204 21.1718 21.3456 21.4425C21.4855 21.5929 21.6778 21.6838 21.8828 21.6967C22.0878 21.7096 22.2899 21.6434 22.4476 21.5117C22.6052 21.38 22.7064 21.1929 22.7302 20.9888C22.754 20.7848 22.6987 20.5794 22.5756 20.415C22.2005 19.9636 21.7305 19.6005 21.1989 19.3516C20.6674 19.1027 20.0875 18.9741 19.5006 18.975Z"
          fill="#3AA8B8"
        />
        <path
          d="M19.5154 24C19.9586 24 20.3179 23.6407 20.3179 23.1975C20.3179 22.7543 19.9586 22.395 19.5154 22.395C19.0722 22.395 18.7129 22.7543 18.7129 23.1975C18.7129 23.6407 19.0722 24 19.5154 24Z"
          fill="#3AA8B8"
        />
        <path
          d="M12.75 3.6825L6.045 1.5975H16.8C17.0128 1.5975 17.217 1.68205 17.3675 1.83255C17.518 1.98304 17.6025 2.18716 17.6025 2.4V13.5C17.6218 13.6985 17.7142 13.8827 17.8619 14.0167C18.0096 14.1508 18.2018 14.225 18.4012 14.225C18.6007 14.225 18.7929 14.1508 18.9406 14.0167C19.0883 13.8827 19.1807 13.6985 19.2 13.5V2.4C19.2003 2.08491 19.1381 1.77288 19.0171 1.48195C18.8961 1.19102 18.7187 0.926952 18.495 0.705C18.0448 0.256047 17.4358 0.00272339 16.8 0H0.8025C0.591457 0.00568135 0.390622 0.092054 0.241338 0.241338C0.092054 0.390622 0.00568135 0.591457 0 0.8025L0 18.8625C0.00306075 19.5923 0.254159 20.2994 0.712076 20.8677C1.16999 21.4361 1.80752 21.8318 2.52 21.99L11.52 23.9475C11.8651 24.0166 12.2211 24.0094 12.5631 23.9265C12.9051 23.8436 13.2249 23.6869 13.5 23.4675C13.7809 23.244 14.0077 22.96 14.1635 22.6367C14.3193 22.3133 14.4002 21.9589 14.4 21.6V6C14.4092 5.48799 14.2539 4.98653 13.9569 4.56937C13.6599 4.1522 13.2368 3.84134 12.75 3.6825ZM12.8325 21.6C12.8326 21.7196 12.8056 21.8378 12.7537 21.9456C12.7017 22.0533 12.6261 22.148 12.5325 22.2225C12.4386 22.2971 12.3294 22.3499 12.2127 22.3771C12.096 22.4043 11.9747 22.4053 11.8575 22.38L2.8575 20.4225C2.50095 20.3426 2.1821 20.144 1.95319 19.8593C1.72427 19.5745 1.59886 19.2204 1.5975 18.855V1.89L12.24 5.2125C12.4011 5.26177 12.5425 5.36096 12.6436 5.49576C12.7447 5.63057 12.8003 5.79401 12.8025 5.9625L12.8325 21.6Z"
          fill="#3AA8B8"
        />
        <path
          d="M10.402 12C10.1891 12 9.985 12.0845 9.8345 12.235C9.684 12.3855 9.59945 12.5897 9.59945 12.8025V15.2025C9.58865 15.3139 9.60126 15.4263 9.63648 15.5326C9.67171 15.6388 9.72876 15.7365 9.80398 15.8194C9.87921 15.9022 9.97093 15.9684 10.0733 16.0138C10.1756 16.0591 10.2863 16.0825 10.3982 16.0825C10.5101 16.0825 10.6208 16.0591 10.7231 16.0138C10.8255 15.9684 10.9172 15.9022 10.9924 15.8194C11.0676 15.7365 11.1247 15.6388 11.1599 15.5326C11.1951 15.4263 11.2078 15.3139 11.197 15.2025V12.8025C11.197 12.591 11.1134 12.388 10.9646 12.2377C10.8157 12.0874 10.6135 12.002 10.402 12Z"
          fill="#3AA8B8"
        />
      </g>
      <defs>
        <clipPath id="clip0_1365_11855">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
const doorcontactsensoroff = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1365_11855)">
        <path
          d="M23.8133 17.79C23.2882 17.1589 22.6307 16.651 21.8873 16.3024C21.144 15.9539 20.333 15.7732 19.512 15.7732C18.691 15.7732 17.8801 15.9539 17.1367 16.3024C16.3934 16.651 15.7358 17.1589 15.2108 17.79C15.0877 17.9545 15.0324 18.1599 15.0562 18.3639C15.08 18.5679 15.1812 18.755 15.3388 18.8867C15.4964 19.0184 15.6986 19.0846 15.9036 19.0718C16.1086 19.0589 16.3008 18.9679 16.4408 18.8175C16.8159 18.3672 17.2855 18.0049 17.8163 17.7563C18.347 17.5077 18.9259 17.3788 19.512 17.3788C20.0981 17.3788 20.677 17.5077 21.2078 17.7563C21.7385 18.0049 22.2081 18.3672 22.5833 18.8175C22.6486 18.9048 22.731 18.9778 22.8254 19.0322C22.9199 19.0866 23.0245 19.1212 23.1327 19.1338C23.241 19.1464 23.3507 19.1369 23.4552 19.1057C23.5596 19.0746 23.6566 19.0225 23.7403 18.9526C23.8239 18.8827 23.8925 18.7965 23.9417 18.6993C23.991 18.602 24.0199 18.4958 24.0267 18.387C24.0335 18.2782 24.0181 18.1692 23.9814 18.0665C23.9447 17.9639 23.8875 17.8698 23.8133 17.79Z"
          fill="#E3E3E3"
        />
        <path
          d="M19.5006 18.975C18.9137 18.9741 18.3338 19.1027 17.8023 19.3516C17.2708 19.6005 16.8007 19.9636 16.4256 20.415C16.3025 20.5794 16.2472 20.7848 16.271 20.9888C16.2949 21.1929 16.396 21.38 16.5536 21.5117C16.7113 21.6434 16.9134 21.7096 17.1184 21.6967C17.3234 21.6838 17.5157 21.5929 17.6556 21.4425C17.8808 21.1718 18.1629 20.9539 18.4817 20.8044C18.8006 20.6549 19.1484 20.5774 19.5006 20.5774C19.8528 20.5774 20.2006 20.6549 20.5195 20.8044C20.8383 20.9539 21.1204 21.1718 21.3456 21.4425C21.4855 21.5929 21.6778 21.6838 21.8828 21.6967C22.0878 21.7096 22.2899 21.6434 22.4476 21.5117C22.6052 21.38 22.7064 21.1929 22.7302 20.9888C22.754 20.7848 22.6987 20.5794 22.5756 20.415C22.2005 19.9636 21.7305 19.6005 21.1989 19.3516C20.6674 19.1027 20.0875 18.9741 19.5006 18.975Z"
          fill="#E3E3E3"
        />
        <path
          d="M19.5154 24C19.9586 24 20.3179 23.6407 20.3179 23.1975C20.3179 22.7543 19.9586 22.395 19.5154 22.395C19.0722 22.395 18.7129 22.7543 18.7129 23.1975C18.7129 23.6407 19.0722 24 19.5154 24Z"
          fill="#E3E3E3"
        />
        <path
          d="M12.75 3.6825L6.045 1.5975H16.8C17.0128 1.5975 17.217 1.68205 17.3675 1.83255C17.518 1.98304 17.6025 2.18716 17.6025 2.4V13.5C17.6218 13.6985 17.7142 13.8827 17.8619 14.0167C18.0096 14.1508 18.2018 14.225 18.4012 14.225C18.6007 14.225 18.7929 14.1508 18.9406 14.0167C19.0883 13.8827 19.1807 13.6985 19.2 13.5V2.4C19.2003 2.08491 19.1381 1.77288 19.0171 1.48195C18.8961 1.19102 18.7187 0.926952 18.495 0.705C18.0448 0.256047 17.4358 0.00272339 16.8 0H0.8025C0.591457 0.00568135 0.390622 0.092054 0.241338 0.241338C0.092054 0.390622 0.00568135 0.591457 0 0.8025L0 18.8625C0.00306075 19.5923 0.254159 20.2994 0.712076 20.8677C1.16999 21.4361 1.80752 21.8318 2.52 21.99L11.52 23.9475C11.8651 24.0166 12.2211 24.0094 12.5631 23.9265C12.9051 23.8436 13.2249 23.6869 13.5 23.4675C13.7809 23.244 14.0077 22.96 14.1635 22.6367C14.3193 22.3133 14.4002 21.9589 14.4 21.6V6C14.4092 5.48799 14.2539 4.98653 13.9569 4.56937C13.6599 4.1522 13.2368 3.84134 12.75 3.6825ZM12.8325 21.6C12.8326 21.7196 12.8056 21.8378 12.7537 21.9456C12.7017 22.0533 12.6261 22.148 12.5325 22.2225C12.4386 22.2971 12.3294 22.3499 12.2127 22.3771C12.096 22.4043 11.9747 22.4053 11.8575 22.38L2.8575 20.4225C2.50095 20.3426 2.1821 20.144 1.95319 19.8593C1.72427 19.5745 1.59886 19.2204 1.5975 18.855V1.89L12.24 5.2125C12.4011 5.26177 12.5425 5.36096 12.6436 5.49576C12.7447 5.63057 12.8003 5.79401 12.8025 5.9625L12.8325 21.6Z"
          fill="#E3E3E3"
        />
        <path
          d="M10.402 12C10.1891 12 9.985 12.0845 9.8345 12.235C9.684 12.3855 9.59945 12.5897 9.59945 12.8025V15.2025C9.58865 15.3139 9.60126 15.4263 9.63648 15.5326C9.67171 15.6388 9.72876 15.7365 9.80398 15.8194C9.87921 15.9022 9.97093 15.9684 10.0733 16.0138C10.1756 16.0591 10.2863 16.0825 10.3982 16.0825C10.5101 16.0825 10.6208 16.0591 10.7231 16.0138C10.8255 15.9684 10.9172 15.9022 10.9924 15.8194C11.0676 15.7365 11.1247 15.6388 11.1599 15.5326C11.1951 15.4263 11.2078 15.3139 11.197 15.2025V12.8025C11.197 12.591 11.1134 12.388 10.9646 12.2377C10.8157 12.0874 10.6135 12.002 10.402 12Z"
          fill="#E3E3E3"
        />
      </g>
      <defs>
        <clipPath id="clip0_1365_11855">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
const motionseneoroff = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <rect x="0.5" y="0.5" width="23" height="23" rx="3.5" stroke="#E3E3E3" />
      <path
        d="M15.3555 3.75C15.7726 4.7402 17.2267 4.7397 17.6435 3.75H15.3555Z"
        fill="#E3E3E3"
      />
      <path
        d="M19.5003 1C18.8266 1 14.1745 1 13.5003 1C13.1726 1.00527 13.171 1.49437 13.5003 1.5H13.7503V2.75C13.7503 3.16357 14.0867 3.5 14.5003 3.5H18.5003C18.9138 3.5 19.2503 3.16357 19.2503 2.75V1.5H19.5003C19.8289 1.49442 19.8288 1.00552 19.5003 1ZM15.5003 2.5C15.1717 2.49443 15.1717 2.00552 15.5003 2C15.8289 2.00557 15.8288 2.49448 15.5003 2.5ZM16.5003 2.5C16.1717 2.49443 16.1717 2.00552 16.5003 2C16.8289 2.00557 16.8288 2.49448 16.5003 2.5ZM17.5003 2.5C17.1717 2.49443 17.1717 2.00552 17.5003 2C17.8289 2.00557 17.8288 2.49448 17.5003 2.5Z"
        fill="#E3E3E3"
      />
      <path
        d="M16.5414 5.49943C15.7123 5.51198 14.8096 4.99573 14.4898 4.26308C14.4321 4.13773 14.4868 3.98928 14.6122 3.93143C14.7372 3.87345 14.886 3.92838 14.9439 4.05385C15.1235 4.44325 15.4944 4.7538 15.9619 4.90565C16.4293 5.0575 16.9122 5.02443 17.2861 4.81483C17.4069 4.74768 17.5589 4.7904 17.6264 4.91078C17.8364 5.3704 16.8547 5.49598 16.5414 5.49943Z"
        fill="#E3E3E3"
      />
      <path
        d="M16.5477 6.49998C15.3508 6.51703 14.0753 5.7781 13.5991 4.7192C13.5402 4.59435 13.5938 4.4453 13.7187 4.38645C13.8433 4.32773 13.9926 4.3812 14.0515 4.50608C14.3447 5.12863 14.9284 5.62058 15.6529 5.85605C16.3777 6.0914 17.1393 6.0366 17.7422 5.70543C17.8634 5.63915 18.0151 5.68308 18.0816 5.80418C18.3321 6.30945 16.89 6.51275 16.5477 6.49998Z"
        fill="#E3E3E3"
      />
      <path
        d="M16.5459 7.49905C14.9805 7.51972 13.3537 6.563 12.7085 5.17567C12.6485 5.05142 12.7006 4.9019 12.825 4.84195C12.9493 4.78177 13.0987 4.83402 13.1587 4.9584C13.5732 5.81667 14.3697 6.49037 15.3439 6.80702C16.3182 7.12317 17.3586 7.0464 18.1984 6.59585C18.3201 6.5303 18.4717 6.57595 18.5369 6.69777C18.6022 6.81947 18.5566 6.97097 18.435 7.03627C17.8633 7.34315 17.2123 7.49905 16.5459 7.49905Z"
        fill="#E3E3E3"
      />
      <path
        d="M14.2498 9.25C14.2498 10.0784 13.5782 10.75 12.7498 10.75C10.7641 10.6814 10.7646 7.8183 12.7498 7.75C13.5782 7.75 14.2498 8.42158 14.2498 9.25Z"
        fill="#E3E3E3"
      />
      <path
        d="M16.1146 14.0644L18.5902 13.5009C18.9279 13.4246 19.1356 13.0824 19.0492 12.7475C18.9702 12.4051 18.6309 12.1939 18.2919 12.2737C17.4174 12.4796 15.917 12.826 15.917 12.826L10.5056 10.4292C10.3136 10.3441 10.1033 10.3088 9.89406 10.3265L7.03846 10.5679C6.81509 10.5868 6.60449 10.68 6.44024 10.8325L4.57836 12.5618C3.98874 13.141 4.84279 14.0186 5.44846 13.4708C6.10361 12.8565 7.23144 11.8048 7.23144 11.8048L9.60801 11.5969C9.57229 11.7056 7.64516 15.7187 7.74146 15.6937L7.05294 18.7328L5.69689 20.5624C5.05919 21.5229 6.44399 22.4955 7.13041 21.5662L8.56561 19.6138C8.66041 19.4848 8.72956 19.3389 8.76931 19.1838L9.22719 17.3976L10.231 20.1176V22.1249C10.2664 23.2808 11.9453 23.2818 11.981 22.1249V20.0735C12.0274 19.7776 11.0337 16.8404 10.955 16.4899L12.8568 12.9116L15.4668 13.9952C15.669 14.0895 15.897 14.1139 16.1146 14.0644Z"
        fill="#E3E3E3"
      />
    </svg>
  );
};
const fanSwing = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <g clipPath="url(#clip0_50_11061)">
        <path
          d="M13.8257 2.58612L14.621 6.56375C14.6344 6.6303 14.6656 6.69197 14.7112 6.7422C14.7569 6.79244 14.8153 6.82933 14.8803 6.84896C14.9452 6.8686 15.0143 6.87022 15.0801 6.85368C15.146 6.83713 15.2061 6.80302 15.254 6.755L15.779 6.23C17.445 8.03359 18.3702 10.3987 18.3702 12.854C18.3702 15.3093 17.445 17.6744 15.779 19.478L15.254 18.953C15.2061 18.905 15.146 18.8709 15.0801 18.8543C15.0143 18.8378 14.9452 18.8394 14.8803 18.859C14.8153 18.8787 14.7569 18.9156 14.7112 18.9658C14.6656 19.016 14.6344 19.0777 14.621 19.1442L13.8257 23.1219C13.8135 23.1824 13.8165 23.245 13.8344 23.3042C13.8523 23.3633 13.8845 23.4171 13.9282 23.4607C13.9719 23.5044 14.0256 23.5366 14.0848 23.5545C14.1439 23.5724 14.2065 23.5754 14.267 23.5632L18.2443 22.7679C18.3109 22.7546 18.3726 22.7235 18.4229 22.6778C18.4731 22.6322 18.5101 22.5738 18.5298 22.5088C18.5494 22.4438 18.5511 22.3747 18.5346 22.3088C18.518 22.243 18.4839 22.1829 18.4359 22.1349L17.9019 21.6005C20.1289 19.2327 21.3688 16.1045 21.3688 12.854C21.3688 9.60345 20.1289 6.47531 17.9019 4.1075L18.4359 3.57312C18.4839 3.52513 18.518 3.465 18.5346 3.39915C18.5511 3.3333 18.5494 3.26419 18.5298 3.19921C18.5101 3.13423 18.4731 3.0758 18.4229 3.03017C18.3726 2.98454 18.3109 2.95342 18.2443 2.94012L14.267 2.14475C14.2065 2.13261 14.1439 2.13562 14.0848 2.15351C14.0256 2.17139 13.9719 2.2036 13.9282 2.24727C13.8845 2.29094 13.8523 2.34472 13.8344 2.40384C13.8165 2.46295 13.8135 2.52557 13.8257 2.58612Z"
          fill="#56585D"
        />
        <path
          d="M6.46973 12.104C6.05551 12.104 5.71973 12.4398 5.71973 12.854C5.71973 13.2682 6.05551 13.604 6.46973 13.604H11.7197C12.1339 13.604 12.4697 13.2682 12.4697 12.854C12.4697 12.4398 12.1339 12.104 11.7197 12.104H6.46973Z"
          fill="#56585D"
        />
        <path
          d="M6.02542 16.1253C5.63618 15.9836 5.2058 16.1843 5.06413 16.5736C4.92246 16.9628 5.12315 17.3932 5.51239 17.5348L10.4458 19.3304C10.835 19.4721 11.2654 19.2714 11.4071 18.8822C11.5487 18.493 11.348 18.0626 10.9588 17.9209L6.02542 16.1253Z"
          fill="#56585D"
        />
        <path
          d="M4.23207 19.7517C3.91477 19.4855 3.4417 19.5269 3.17545 19.8442C2.9092 20.1615 2.95059 20.6345 3.26789 20.9008L7.28963 24.2754C7.60693 24.5417 8.08 24.5003 8.34625 24.183C8.6125 23.8657 8.57111 23.3926 8.25381 23.1264L4.23207 19.7517Z"
          fill="#56585D"
        />
        <path
          d="M10.9587 7.78715C11.3479 7.64548 11.5486 7.2151 11.4069 6.82586C11.2652 6.43663 10.8349 6.23594 10.4456 6.37761L5.51223 8.17321C5.123 8.31488 4.92231 8.74527 5.06398 9.1345C5.20565 9.52373 5.63603 9.72442 6.02527 9.58275L10.9587 7.78715Z"
          fill="#56585D"
        />
        <path
          d="M8.25391 2.5816C8.57121 2.31535 8.6126 1.84228 8.34635 1.52497C8.0801 1.20767 7.60703 1.16628 7.28972 1.43253L3.26799 4.80717C2.95069 5.07342 2.9093 5.54648 3.17555 5.86379C3.4418 6.1811 3.91487 6.22248 4.23217 5.95623L8.25391 2.5816Z"
          fill="#56585D"
        />
      </g>
      <defs>
        <clipPath id="clip0_50_11061">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="matrix(0 -1 1 0 0 24.854)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
const fanStop = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <g clipPath="url(#clip0_50_11077)">
        <path
          d="M15.1693 9.39014H8.83103C8.67928 9.39014 8.55469 9.50914 8.55469 9.66328V16.0702C8.55469 16.2212 8.67848 16.3449 8.83103 16.3449H15.1693C15.321 16.3449 15.444 16.222 15.444 16.0702V9.66328C15.4432 9.50994 15.321 9.39014 15.1693 9.39014Z"
          fill="#56585D"
        />
        <path
          d="M12.001 0.854004C5.37442 0.854004 0.000976562 6.22585 0.000976562 12.854C0.000976562 19.4822 5.37442 24.854 12.001 24.854C18.6283 24.854 23.9994 19.4822 23.9994 12.854C23.9994 6.22585 18.6283 0.854004 12.001 0.854004ZM12.001 22.8493C6.48058 22.8493 2.00484 18.3736 2.00484 12.854C2.00484 7.33201 6.48058 2.85707 12.001 2.85707C17.5222 2.85707 21.9955 7.33201 21.9955 12.854C21.9955 18.3736 17.5222 22.8493 12.001 22.8493Z"
          fill="#56585D"
        />
      </g>
      <defs>
        <clipPath id="clip0_50_11077">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.854004)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
const Controller = {
  heart,
  heartF,
  refresh,
  wind,
  erv,
  doas,
  air,
  dry,
  cool,
  eco,
  floor_lamp,
  chandelier,
  curtain,
  less,
  more_than,
  pause,
  plus,
  plusD,
  minus,
  minusD,
  cross,
  door,
  unlock,
  lock,
  motionseneor,
  doorcontactsensor,
  freshair,
  freshairOff,
  heat,
  vent,
  supply,
  ervOff,
  auto,
  doorcontactsensoroff,
  motionseneoroff,
  fanSwing,
  fanStop,
};
export default Controller;
